import React, { Component, Fragment } from "react";
import Breadcrumb from "../common/breadcrumb";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { Tabs, TabList, TabPanel, Tab } from "react-tabs";
import {
  updateProduct,
  updateProductInventory,
  updateTransaction,
  updateTransactionOrderStatus,
  getSingleProduct,
  getSingleOrder,
} from "../../firebase/firebase.utils";
import FullPageLoader from "./fullPageLoder.js";
import {
  getAllOrdersRedux,
  updateOrderRedux,
  uploadCashInRedux,
  uploadTransactionRedux,
  updateSingleProductRedux,
  uploadExpenseRedux,
} from "../../actions/index";
import { Search } from "react-feather";
import { sendNotifications } from "../../firebase/fcmRestApi";
import SteadFast from "./steadFast.png";
import Pathao from "./pathao.png";
import axios from "axios";
import { ClipLoader } from "react-spinners";
import loader from "sass-loader";
import ReactToPrint from "react-to-print";
import logo from "./zapai2.png";
import Barcode from "react-barcode";
import "./new.css";
// steadFast api credential
const api_key = "xzxz8veesykaes09owbphuqbel5yx6cx";
const secret_key = "uuvywmhr3amooqiyjnaf7l9v";
const base_url = "https://portal.packzy.com/api/v1";

const orderCache = {};
export class Orders extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      toggleModal: true,
      singleLot: null,
      expenseObj: null,
      loader: false,
      loader2: false,
      type: "upload",
      checkedValues: [],
      checkedValues2: [],
      id: "",
      name: "",
      quantity: "",
      amount: "",
      description: "",
      searchFor: "",
      orderObj: null,
      loading: false,
      imageUrl: "",
      file: "",
      type: "",
      customer: "",
      customerUid: "",
      cursor: -1,
      shippingCost: "",
      agentCost: "",
      status: "",
      warehouse: "",
      orderStatus: "",
      courier: "",
      note: "",
      loader: false,
      method: "",
      amount: 0,
      paymentStatus: "",
      transactionId: "",
      cancelNote: "",
      weight: "",
      cityList: [],
      areaList: [],
      loader3: false,
      courierCharge: "",
      loading4: false,
      loading5: false,
    };
  }

  componentDidMount = async () => {
    window.addEventListener("scroll", this.handleScroll);
    this.setState({
      loading4: true,
    });
    const { orderStatus } = this.props.match.params;
    const { getAllOrdersRedux } = this.props;
    console.log(orderStatus);
    await getAllOrdersRedux(orderStatus, null);
    this.setState({
      loading4: false,
    });
  };
  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll = async () => {
    const { loading5 } = this.state;
    const { hasMore, lastVisible } = this.props;

    // Stop if already loading or no more data
    if (loading5 || !hasMore) return;

    const scrollTop = window.scrollY;
    const windowHeight = window.innerHeight;
    const fullHeight = document.documentElement.scrollHeight;

    if (scrollTop < 100) return;
    if (scrollTop + windowHeight >= fullHeight - 100) {
      // Near the bottom
      this.setState({ loading5: true });

      const { orderStatus } = this.props.match.params;
      const { getAllOrdersRedux } = this.props;
      console.log("calling get all orders from client");
      await getAllOrdersRedux(orderStatus, lastVisible); // Pass cursor

      this.setState({ loading5: false });
    }
  };

  UNSAFE_componentWillReceiveProps = async (nextProps) => {
    const { orderStatus } = this.props.match.params;
    const orderStatus2 = nextProps.match.params.orderStatus;
    if (orderStatus !== orderStatus2) {
      this.setState({
        loading4: true,
      });
      const { getAllOrdersRedux } = this.props;
      console.log(orderStatus2);
      await getAllOrdersRedux(orderStatus2, null);
      this.setState({
        loading4: false,
      });
    }
  };

  calculateCart = (orders) => {
    let cartProducts = orders;
    let sumAmount = 0;
    let actualOrder = 0;

    //find and create array
    cartProducts &&
      cartProducts.length > 0 &&
      cartProducts.forEach((item, index) => {
        let price = this.getPrice4(item);
        let salePrice = this.getPrice2(item);
        console.log(price);
        console.log(item.quantity);
        actualOrder += parseInt(parseInt(price) * item.quantity);
        sumAmount += parseInt(parseInt(salePrice) * item.quantity);
      });

    return { actualOrder, sumAmount };
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
    });
  };

  handleSearchBarChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };

  clickActive = (event) => {
    document.querySelector(".nav-link").classList.remove("show");
    event.target.classList.add("show");
  };

  getDeliveryAddress = (orderObj) => {
    let deliveryAddress = null;
    if (
      orderObj &&
      orderObj.currentUser &&
      orderObj.currentUser.address &&
      orderObj.currentUser.address.length > 0
    ) {
      deliveryAddress = orderObj.currentUser.address.find(
        (address) => address.defaultShipping
      );
    } else if (
      orderObj &&
      orderObj.guest &&
      orderObj.guest.address &&
      orderObj.guest.address.length > 0
    ) {
      deliveryAddress = orderObj.guest.address.find(
        (address) => address.defaultShipping
      );
    }
    return deliveryAddress;
  };

  createNotification = (order) => {
    let msg;
    console.log(order);

    if (order.orderStatus === "Processing") {
      msg = {
        title: "Order Processing",
        body: `We are processing your order.One of our team member is assigned for your order. OrderId:-${order.id}.`,
      };
      return msg;
    }
    if (order.orderStatus === "Confirmed") {
      msg = {
        title: "Order Confirmed",
        body: `Your order is confirmed. OrderId:-${order.id}.`,
      };
      return msg;
    }
    if (order.orderStatus === "Packing") {
      msg = {
        title: "Reday for delivery",
        body: `We are packaging your order. OrderId:-${order.id}.`,
      };
      return msg;
    }
    if (order.orderStatus === "On the way") {
      msg = {
        title: "On the way",
        body: `Your parcel is out for delivery. OrderId:-${order.id}.`,
      };
      return msg;
    }
    if (order.orderStatus === "Delivered") {
      msg = {
        title: "Order delivered successfully",
        body: `Your order is delivered. OrderId:-${order.id}. Thank you`,
      };
      return msg;
    }
    if (order.orderStatus === "Cancelled") {
      msg = {
        title: "Sorry. Order cancelled",
        body: `Your order is cancelled. OrderId:-${order.id}.Contact our customer service to get detail info.Thanks`,
      };
      return msg;
    }
  };

  handleCourier = async (codAmount) => {
    const { orderObj } = this.state;
    let note = this.state.note;
    if (this.state.courier == "SteadFast") {
      const create_order = `${base_url}/create_order`;

      console.log(note);
      axios
        .post(
          create_order,
          {
            invoice: `${orderObj.id}`,
            recipient_name: orderObj.currentUser
              ? orderObj.currentUser.address.find(
                  (address) => address.defaultShipping
                ).fullName
              : orderObj.guest.address.find(
                  (address) => address.defaultShipping
                ).fullName,
            recipient_phone: orderObj.currentUser
              ? orderObj.currentUser.address.find(
                  (address) => address.defaultShipping
                ).mobileNo
              : orderObj.guest.address.find(
                  (address) => address.defaultShipping
                ).mobileNo,
            recipient_address: orderObj.currentUser
              ? `${
                  orderObj.currentUser.address.find(
                    (address) => address.defaultShipping
                  ).address
                },${
                  orderObj.currentUser.address.find(
                    (address) => address.defaultShipping
                  ).district
                },${
                  orderObj.currentUser.address.find(
                    (address) => address.defaultShipping
                  ).division
                }`
              : `${
                  orderObj.guest.address.find(
                    (address) => address.defaultShipping
                  ).address
                },${
                  orderObj.guest.address.find(
                    (address) => address.defaultShipping
                  ).district
                },${
                  orderObj.guest.address.find(
                    (address) => address.defaultShipping
                  ).division
                }`,
            cod_amount: codAmount,
            note: note,
          }, // Request body (if needed)
          {
            headers: {
              "Api-Key": api_key,
              "Secret-Key": secret_key,
              "Content-Type": "application/json",
            },
          }
        )
        .then(async (response) => {
          console.log(note);
          await this.props.updateOrderRedux({
            ...orderObj,
            courier: { ...response.data, note: note },
          });
          toast.success(
            "Consignment has been created successfully at steadfast!"
          );
          window.document.getElementById("close-btn-courier").click();
        })
        .catch((error) => {
          toast.error("Error creating consignment at steadfast.");
        });
      console.log("Handle submit is getting called!");
    } else {
      // for pathao
      // first get the access token
      if (!this.state.cityObject) {
        alert("You must choose a city");
        return;
      }
      if (!this.state.zoneObject) {
        alert("You must choose a zone");
        return;
      }
      if (!this.state.access_token) {
        alert(
          "Your token is expired. Please open and close the modal windo again"
        );
        window.document.getElementById("close-btn-courier").click();
        return;
      }

      let baseUrl = `https://admin.zapai.com.bd`;

      let totalQuantity = 0;
      orderObj.orders.map((order) => {
        totalQuantity += order.quantity;
      });
      // create order here
      let order = {
        store_id: 151431,
        merchant_order_id: `${orderObj.id}`,
        recipient_name: orderObj.currentUser
          ? orderObj.currentUser.address.find(
              (address) => address.defaultShipping
            ).fullName
          : orderObj.guest.address.find((address) => address.defaultShipping)
              .fullName,
        recipient_phone: orderObj.currentUser
          ? orderObj.currentUser.address.find(
              (address) => address.defaultShipping
            ).mobileNo
          : orderObj.guest.address.find((address) => address.defaultShipping)
              .mobileNo,
        recipient_address: orderObj.currentUser
          ? `${
              orderObj.currentUser.address.find(
                (address) => address.defaultShipping
              ).address
            },${
              orderObj.currentUser.address.find(
                (address) => address.defaultShipping
              ).district
            },${
              orderObj.currentUser.address.find(
                (address) => address.defaultShipping
              ).division
            }`
          : `${
              orderObj.guest.address.find((address) => address.defaultShipping)
                .address
            },${
              orderObj.guest.address.find((address) => address.defaultShipping)
                .district
            },${
              orderObj.guest.address.find((address) => address.defaultShipping)
                .division
            }`,
        delivery_type: 48,
        item_type: 2,
        special_instruction: note,
        item_quantity: parseInt(totalQuantity),
        item_weight: this.state.weight
          ? parseFloat(this.state.weight).toFixed(2)
          : parseFloat(1),
        item_description: "",
        amount_to_collect: parseInt(codAmount),
        recipient_city: parseInt(this.state.cityObject.city_id),
        recipient_zone: parseInt(this.state.zoneObject.zone_id),
      };
      console.log(order);
      axios
        .post(`${baseUrl}/api/create-order`, order, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.state.access_token}`,
          },
        })
        .then(async (response) => {
          console.log(response);
          if (response.data.code == 200) {
            console.log(note);
            await this.props.updateOrderRedux({
              ...orderObj,
              courier: {
                ...response.data.data,
                pathao: true,
                weight: this.state.weight ? this.state.weight : 1,
                city: this.state.cityObject,
                zone: this.state.zoneObject,
                note: note,
              },
            });
            toast.success(
              "Consignment has been created successfully at pathao!"
            );
          } else {
            alert("error creating consignment. Please try again later.");
          }
        })
        .catch((error) => {
          alert("error creating order.");
        });
    }

    this.setState({
      name: "",
      quantity: "",
      amount: "",
      description: "",
      orderObj: null,
      loading: false,
      imageUrl: "",
      file: "",
      shippingCost: "",
      agentCost: "",
      status: "",
      warehouse: "",
      orderStatus: "",
      courier: "",
      note: "",
    });
  };

  getUserName = (agentId) => {
    const { users } = this.props;
    if (users.length > 0) {
      const agentName = users.find((user) => user.uid === agentId);
      if (agentName) {
        return agentName.displayName;
      } else {
        return "";
      }
    } else {
      return "";
    }
  };

  selectRow = (e, i) => {
    if (!e.target.checked) {
      this.setState({
        checkedValues: this.state.checkedValues.filter((item, j) => i !== item),
      });
    } else {
      this.setState({
        checkedValues: [...this.state.checkedValues, i],
      });
    }
  };
  selectRow2 = (e, i) => {
    if (!e.target.checked) {
      this.setState({
        checkedValues2: this.state.checkedValues2.filter(
          (item, j) => i !== item
        ),
      });
    } else {
      this.setState({
        checkedValues2: [...this.state.checkedValues2, i],
      });
    }
  };

  singleProductTotal = (product) => {
    let total = parseInt(this.getPrice2(product)) * product.quantity;
    return total;
  };

  getPrice2 = (product) => {
    if (product.selectedVariation.id) {
      if (product.selectedVariation.salePrice == 0) {
        return product.selectedVariation.price;
      } else {
        return product.selectedVariation.salePrice;
      }
    } else {
      if (product.product) {
        if (product.product.salePrice == 0) {
          return product.product.price;
        } else {
          return product.product.salePrice;
        }
      } else {
        return 0;
      }
    }
  };

  getMonthName = () => {
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    const d = new Date();
    return `${monthNames[d.getMonth()]},${d.getFullYear()}`;
  };

  handleSubmit = async () => {
    console.log("Handle submit is getting called!");
    let orderObj = {
      ...this.state.orderObj,
      orderStatus: this.state.orderStatus,
      [`${this.state.orderStatus.toLowerCase()}Date`]: new Date()
        .getTime()
        .toString(),
      orderStatusScore:
        this.state.orderStatus == "Processing"
          ? 2
          : this.state.orderStatus == "Confirmed"
          ? 3
          : this.state.orderStatus == "Packing"
          ? 4
          : this.state.orderStatus == "On the way"
          ? 5
          : this.state.orderStatus == "Delivered"
          ? 6
          : 0,
      cancelNote: this.state.cancelNote,
    };

    await this.props.updateOrderRedux(orderObj);
    const msg = this.createNotification(orderObj);
    const message = {
      title: msg.title,
      body: msg.body,
    };
    if (
      orderObj &&
      orderObj.currentUser &&
      orderObj.currentUser.deviceToken &&
      orderObj.currentUser.deviceToken.length > 0
    ) {
      orderObj.currentUser.deviceToken.map((token) => {
        console.log(token);
        sendNotifications(token, message);
      });
    }

    for (let i = 0; i < orderObj.orders.length; i++) {
      let product = await getSingleProduct(orderObj.orders[i].productId);
      let order = orderObj.orders[i];
      if (this.state.orderStatus == "Cancelled") {
        if (
          product.displayedVariations &&
          product.displayedVariations.length > 0
        ) {
          await this.props.updateSingleProductRedux({
            ...product,
            displayedVariations: product.displayedVariations.map(
              (variation) => {
                if (order.selectedVariation.id == variation.id) {
                  return {
                    ...variation,
                    totalSold: variation.totalSold
                      ? variation.totalSold - parseInt(order.quantity)
                      : 0,
                    inventory:
                      parseInt(variation.inventory) +
                      parseInt(
                        orderObj.orders.find(
                          (order) => order.selectedVariation.id == variation.id
                        ).quantity
                      ),
                  };
                } else {
                  return variation;
                }
              }
            ),
          });
          let date = new Date();
          this.props.uploadTransactionRedux({
            id: date.getTime().toString() + i,
            fundType: "Buying",
            subCategory: `Order Id:${orderObj.id}`,
            month: this.getMonthName(),
            date: date.toLocaleDateString("en-GB"),
            purchasePrice: "Cancelled by admin",
            cancelNote: this.state.cancelNote,
            orderStatus: "Cancelled",
            totalCost: this.singleProductTotal(orderObj.orders[i]),
            perUnitPrice: this.getPrice2(orderObj.orders[i]),
            expenseBy: this.props.currentAdmin
              ? this.props.currentAdmin.name
              : "",
            unEditable: true,
            productId: product.id,
            productStock: orderObj.orders[i].quantity,
            remainingStock:
              parseInt(
                product.displayedVariations.find(
                  (variation) => variation.id == order.selectedVariation.id
                ).inventory
              ) + parseInt(order.quantity),
            productName: product.name,
            productImage: product.pictures[0],
            variationId: order.selectedVariation.id,
          });
        } else {
          await this.props.updateSingleProductRedux({
            ...product,
            totalSold: product.totalSold
              ? parseInt(product.totalSold) -
                parseInt(orderObj.orders[i].quantity)
              : 0,
            inventory:
              parseInt(product.inventory) +
              parseInt(orderObj.orders[i].quantity),
          });
          let date = new Date();
          this.props.uploadTransactionRedux({
            id: date.getTime().toString() + i,
            fundType: "Buying",
            subCategory: `Order Id:${orderObj.id}`,
            month: this.getMonthName(),
            date: date.toLocaleDateString("en-GB"),
            purchasePrice: "Cancelled by admin",
            cancelNote: this.state.cancelNote,
            orderStatus: "Cancelled",
            totalCost: this.singleProductTotal(orderObj.orders[i]),
            perUnitPrice: this.getPrice2(orderObj.orders[i]),
            expenseBy: this.props.currentAdmin
              ? this.props.currentAdmin.name
              : "",
            unEditable: true,
            productId: product.id,
            productStock: orderObj.orders[i].quantity,
            remainingStock:
              parseInt(product.inventory) +
              parseInt(orderObj.orders[i].quantity),
            productName: product.name,
            productImage: product.pictures[0],
          });
        }
      }
    }
    await updateTransactionOrderStatus({
      orderId: orderObj.id,
      orderStatus: this.state.orderStatus,
    });
    this.setState({
      name: "",
      quantity: "",
      amount: "",
      description: "",
      orderObj: null,
      loading: false,
      imageUrl: "",
      file: "",
      shippingCost: "",
      agentCost: "",
      status: "",
      warehouse: "",
      orderStatus: "",
      courier: "",
      note: "",
      cancelNote: "",
    });
  };
  handleSubmit2 = async (event, totalDue) => {
    event.preventDefault();

    if (totalDue != 0 && this.state.amount == 0) {
      alert("Paid amount must be more than 0");
      return;
    }
    if (this.state.amount > totalDue) {
      alert("Paid amount can't be more than due amount.");
      return;
    }
    console.log(this.state);
    if (this.state.loader) {
      return;
    }
    this.setState({
      loader: true,
    });
    await this.props.updateOrderRedux({
      ...this.state.orderObj,
      paymentStatus:
        this.state.paymentStatus !== ""
          ? this.state.paymentStatus
          : this.state.orderObj.paymentStatus
          ? this.state.orderObj.paymentStatus
          : "purchaseLater",
      payments:
        this.state.orderObj.payments && this.state.orderObj.payments.length > 0
          ? [
              ...this.state.orderObj.payments,
              {
                amount: this.state.amount,
                method: this.state.method,
                receivedBy:
                  this.props.currentAdmin && this.props.currentAdmin.name
                    ? this.props.currentAdmin.name
                    : "",
                date: new Date().toLocaleDateString("en-GB"),
                transactionId: this.state.transactionId,
              },
            ]
          : [
              {
                amount: this.state.amount,
                method: this.state.method,
                receivedBy:
                  this.props.currentAdmin && this.props.currentAdmin.name
                    ? this.props.currentAdmin.name
                    : "",
                date: new Date().toLocaleDateString("en-GB"),
                transactionId: this.state.transactionId,
              },
            ],
    });

    orderCache[this.state.orderObj.id] = {
      ...this.state.orderObj,
      paymentStatus:
        this.state.paymentStatus !== ""
          ? this.state.paymentStatus
          : this.state.orderObj.paymentStatus
          ? this.state.orderObj.paymentStatus
          : "purchaseLater",
      payments:
        this.state.orderObj.payments && this.state.orderObj.payments.length > 0
          ? [
              ...this.state.orderObj.payments,
              {
                amount: this.state.amount,
                method: this.state.method,
                receivedBy:
                  this.props.currentAdmin && this.props.currentAdmin.name
                    ? this.props.currentAdmin.name
                    : "",
                date: new Date().toLocaleDateString("en-GB"),
                transactionId: this.state.transactionId,
              },
            ]
          : [
              {
                amount: this.state.amount,
                method: this.state.method,
                receivedBy:
                  this.props.currentAdmin && this.props.currentAdmin.name
                    ? this.props.currentAdmin.name
                    : "",
                date: new Date().toLocaleDateString("en-GB"),
                transactionId: this.state.transactionId,
              },
            ],
    };

    let date = new Date();
    let cashInObj = {
      id: date.getTime().toString(),
      category: "ORDERS",
      subCategory: this.state.method,
      month: this.getMonthName(),
      date: date.toLocaleDateString("en-GB"),
      note: `Order Id:${this.state.orderObj.id}`,
      amount: this.state.amount,
      receiveBy:
        this.props.currentAdmin && this.props.currentAdmin.name
          ? this.props.currentAdmin.name
          : "",
      status: "pending",
      unEditable: true,
    };

    await this.props.uploadCashInRedux(cashInObj);
    toast.success("successfully updated the payment");

    this.setState({
      method: "",
      amount: "",
      paymentStatus: "",
      transactionId: "",
      loader: false,
    });
    document.getElementById("close-button-for-payment-modal").click();
  };
  handleSubmit3 = async (event) => {
    event.preventDefault();

    console.log(this.state);
    if (this.state.loader3) {
      return;
    }
    this.setState({
      loader3: true,
    });
    await this.props.updateOrderRedux({
      ...this.state.orderObj,
      courierCharge: this.state.orderObj.courierCharge
        ? parseInt(this.state.orderObj.courierCharge) +
          parseInt(this.state.courierCharge)
        : this.state.courierCharge,
    });

    orderCache[this.state.orderObj.id] = {
      ...this.state.orderObj,
      courierCharge: this.state.orderObj.courierCharge
        ? parseInt(this.state.orderObj.courierCharge) +
          parseInt(this.state.courierCharge)
        : this.state.courierCharge,
    };
    let date = new Date();
    let expenseObj = {
      id: date.getTime().toString(),
      category: "COURIER",
      subCategory: `courier charge`,
      month: this.getMonthName(),
      date: date.toLocaleDateString("en-GB"),
      note: `Order Id:${this.state.orderObj.id}`,
      amount: this.state.courierCharge,
      receiveBy:
        this.props.currentAdmin && this.props.currentAdmin.name
          ? this.props.currentAdmin.name
          : "",
      status: "pending",
      unEditable: true,
    };

    await this.props.uploadExpenseRedux(expenseObj);
    toast.success("successfully updated the payment");

    this.setState({
      method: "",
      amount: "",
      paymentStatus: "",
      transactionId: "",
      loader: false,
      courierCharge: "",
      loader3: false,
    });
    document.getElementById("close-button-for-payment-modal").click();
  };
  getTotalPaid = (orderObj) => {
    let totalPaid = 0;
    if (orderObj && orderObj.payments && orderObj.payments.length > 0) {
      orderObj.payments.map((payment) => {
        totalPaid += parseInt(payment.amount);
      });
    }
    return totalPaid;
  };
  getTotalDue = (orderObj) => {
    let totalPaid = 0;
    let amountPayable = 0;
    if (orderObj && orderObj.payments && orderObj.payments.length > 0) {
      orderObj.payments.map((payment) => {
        totalPaid += parseInt(payment.amount);
      });
    }
    if (orderObj) {
      amountPayable =
        orderObj &&
        orderObj.subTotal +
          orderObj.deliveryCharge -
          orderObj.discountApplied -
          (orderObj.couponApplied ? orderObj.couponApplied.discount : 0) -
          (orderObj.finalDiscount ? orderObj.finalDiscount : 0);
    }
    return amountPayable - totalPaid;
  };
  getPrice3 = (product) => {
    if (product.selectedVariation.id) {
      if (product.selectedVariation.salePrice == 0) {
        return "";
      } else {
        return `৳ ${product.selectedVariation.price}`;
      }
    } else {
      if (product.product) {
        if (product.product.salePrice == 0) {
          return "";
        } else {
          return `৳ ${product.product.price}`;
        }
      } else {
        return 0;
      }
    }
  };
  getPrice4 = (product) => {
    if (product.selectedVariation.id) {
      return product.selectedVariation.price;
    } else {
      if (product.product) {
        return product.product.price;
      } else {
        return 0;
      }
    }
  };

  handleCashOut = async (p2pArray) => {
    const { currentAdmin } = this.props;
    let date = new Date();
    if (p2pArray.length == 0) {
      alert("Please select at least one p2p agent to pay");
      return;
    }
    for (let i = 0; i < p2pArray.length; i++) {
      const p2pObj = p2pArray[i];
      console.log(date.getTime().toString());
      console.log(p2pObj);
      await this.props.handleP2pAgentPayRedux({
        ...p2pObj,
        paymentId: `${date.getTime().toString()}${i}`,
        month: this.getMonthName(),
        date: date.toLocaleDateString("en-GB"),
        receiveBy: currentAdmin.name,
      });
    }
    this.setState({
      checkedValues2: [],
    });
  };

  updateOrder = async () => {
    console.log("Handle submit is getting called!");
    let orderObj = {
      ...this.state.orderObj,
    };
    let previousOrder = await getSingleOrder(orderObj.id);
    let previousOrdersArray = previousOrder.orders;
    let newOrdersArray = orderObj.orders;
    const getDifferenceArray = this.getDifferenceArray(
      previousOrdersArray,
      newOrdersArray
    );
    console.log(getDifferenceArray);
    await this.props.updateOrderRedux(orderObj);
    orderCache[orderObj.id] = orderObj;
    const msg = this.createNotification(orderObj);
    const message = {
      title: msg.title,
      body: msg.body,
    };
    if (
      orderObj &&
      orderObj.currentUser &&
      orderObj.currentUser.deviceToken &&
      orderObj.currentUser.deviceToken.length > 0
    ) {
      orderObj.currentUser.deviceToken.map((token) => {
        console.log(token);
        sendNotifications(token, message);
      });
    }
    let orders = getDifferenceArray;
    console.log(orders);
    for (let i = 0; i < orders.length; i++) {
      let order = orders[i];
      if (orders[i].unchanged) {
      } else {
        let product = await getSingleProduct(orders[i].productId);
        if (
          product.displayedVariations &&
          product.displayedVariations.length > 0
        ) {
          if (orders[i].decreased) {
            await this.props.updateSingleProductRedux({
              ...product,
              displayedVariations: product.displayedVariations.map(
                (variation) => {
                  if (order.selectedVariation.id == variation.id) {
                    return {
                      ...variation,
                      totalSold: variation.totalSold
                        ? variation.totalSold - parseInt(order.quantity)
                        : 0,
                      inventory:
                        parseInt(variation.inventory) +
                        parseInt(
                          orders.find(
                            (order) =>
                              order.selectedVariation.id == variation.id
                          ).quantity
                        ),
                    };
                  } else {
                    return variation;
                  }
                }
              ),
            });
            let date = new Date();
            this.props.uploadTransactionRedux({
              id: date.getTime().toString() + i,
              fundType: "Buying",
              subCategory: `Order Id:${orderObj.id}`,
              month: this.getMonthName(),
              date: date.toLocaleDateString("en-GB"),
              purchasePrice: "Partial delivered",
              cancelNote: "Item quantity reduced from order",
              orderStatus: orderObj.orderStatus,
              totalCost: this.singleProductTotal(orders[i]),
              perUnitPrice: this.getPrice2(orders[i]),
              expenseBy: this.props.currentAdmin
                ? this.props.currentAdmin.name
                : "",
              unEditable: true,
              productId: product.id,
              productStock: orders[i].quantity,
              remainingStock:
                parseInt(
                  product.displayedVariations.find(
                    (variation) => variation.id == order.selectedVariation.id
                  ).inventory
                ) + parseInt(order.quantity),
              productName: product.name,
              productImage: product.pictures[0],
              variationId: order.selectedVariation.id,
            });
          }
          if (orders[i].increased) {
            await this.props.updateSingleProductRedux({
              ...product,
              displayedVariations: product.displayedVariations.map(
                (variation) => {
                  if (order.selectedVariation.id == variation.id) {
                    return {
                      ...variation,
                      totalSold: variation.totalSold
                        ? variation.totalSold + parseInt(order.quantity)
                        : parseInt(order.quantity),
                      inventory:
                        parseInt(variation.inventory) -
                        parseInt(
                          orders.find(
                            (order) =>
                              order.selectedVariation.id == variation.id
                          ).quantity
                        ),
                    };
                  } else {
                    return variation;
                  }
                }
              ),
            });
            let date = new Date();
            this.props.uploadTransactionRedux({
              id: date.getTime().toString() + i,
              fundType: "Selling",
              subCategory: `Order Id:${orderObj.id}`,
              orderStatus: orderObj.orderStatus,
              month: this.getMonthName(),
              date: date.toLocaleDateString("en-GB"),
              totalBill: this.singleProductTotal(orders[i]),
              perUnitPrice: this.getPrice2(orders[i]),
              expenseBy: this.props.currentAdmin
                ? this.props.currentAdmin.name
                : "",
              note: "Increased quantity",
              unEditable: true,
              productId: product.id,
              sellStock: orders[i].quantity,
              remainingStock:
                parseInt(
                  product.displayedVariations.find(
                    (variation) => variation.id == order.selectedVariation.id
                  ).inventory
                ) - parseInt(order.quantity),
              productName: product.name,
              productImage: product.pictures[0],
              variationId: order.selectedVariation.id,
            });
          }
        } else {
          if (orders[i].decreased) {
            await this.props.updateSingleProductRedux({
              ...product,
              totalSold: product.totalSold
                ? parseInt(product.totalSold) - parseInt(orders[i].quantity)
                : 0,
              inventory:
                parseInt(product.inventory) + parseInt(orders[i].quantity),
            });
            let date = new Date();
            this.props.uploadTransactionRedux({
              id: date.getTime().toString() + i,
              fundType: "Buying",
              subCategory: `Order Id:${orderObj.id}`,
              month: this.getMonthName(),
              date: date.toLocaleDateString("en-GB"),
              purchasePrice: "Partial delivered",
              cancelNote: "Item quantity reduced from order",
              orderStatus: orderObj.orderStatus,
              totalCost: this.singleProductTotal(orders[i]),
              perUnitPrice: this.getPrice2(orders[i]),
              expenseBy: this.props.currentAdmin
                ? this.props.currentAdmin.name
                : "",
              unEditable: true,
              productId: product.id,
              productStock: orders[i].quantity,
              remainingStock:
                parseInt(product.inventory) + parseInt(orders[i].quantity),
              productName: product.name,
              productImage: product.pictures[0],
            });
          }
          if (orders[i].increased) {
            await this.props.updateSingleProductRedux({
              ...product,
              totalSold: product.totalSold
                ? product.totalSold + parseInt(orders[i].quantity)
                : parseInt(orders[i].quantity),
              inventory:
                parseInt(product.inventory) - parseInt(orders[i].quantity),
            });
            let date = new Date();
            this.props.uploadTransactionRedux({
              id: date.getTime().toString() + i,
              fundType: "Selling",
              subCategory: `Increased quantity in Order Id:${orderObj.id}`,
              orderStatus: orderObj.orderStatus,
              month: this.getMonthName(),
              date: date.toLocaleDateString("en-GB"),
              totalBill: this.singleProductTotal(orders[i]),
              perUnitPrice: this.getPrice2(orders[i]),
              expenseBy: this.props.currentAdmin
                ? this.props.currentAdmin.name
                : "",
              unEditable: true,
              productId: product.id,
              sellStock: orders[i].quantity,
              remainingStock:
                parseInt(product.inventory) - parseInt(orders[i].quantity),
              productName: product.name,
              productImage: product.pictures[0],
            });
          }
        }
      }
    }

    this.setState({
      name: "",
      quantity: "",
      amount: "",
      description: "",
      orderObj: null,
      loading: false,
      imageUrl: "",
      file: "",
      shippingCost: "",
      agentCost: "",
      status: "",
      warehouse: "",
      orderStatus: "",
      courier: "",
      note: "",
      cancelNote: "",
    });
  };

  getProductKey = (product) =>
    `${product.productId}-${product.selectedVariation.id}`;

  // Function to get the difference array
  getDifferenceArray = (array1, array2) => {
    // Create a map of array1 for faster lookup
    const mapArray1 = array1.reduce((acc, item) => {
      const key = this.getProductKey(item);
      if (!acc[key]) {
        acc[key] = item;
      } else {
        acc[key].quantity += item.quantity; // In case there are duplicate productIds with different variations
      }
      return acc;
    }, {});

    // Create the result array
    const result = [];

    // Check for changes based on array2
    array2.forEach((item2) => {
      const key = this.getProductKey(item2);
      const item1 = mapArray1[key];

      if (item1) {
        // Product exists in both arrays, compare quantities
        if (item2.quantity > item1.quantity) {
          result.push({
            ...item2,
            quantity: item2.quantity - item1.quantity,
            increased: true,
          });
        } else if (item2.quantity < item1.quantity) {
          result.push({
            ...item2,
            quantity: item1.quantity - item2.quantity,
            decreased: true,
          });
        } else {
          result.push({
            ...item2,
            unchanged: true,
          });
        }

        // Remove the item from mapArray1 (it has been handled)
        delete mapArray1[key];
      } else {
        // Product exists in array2 but not in array1 (newly added)
        result.push({
          ...item2,
          increased: true,
        });
      }
    });

    // Check for removed items in array1 (those that are not in array2)
    Object.values(mapArray1).forEach((item1) => {
      result.push({
        ...item1,
        quantity: item1.quantity,
        decreased: true,
      });
    });

    return result;
  };
  onClick = async (order) => {
    const orderId = order.id;
    let orderData;

    // Check if the order is already in cache
    if (orderCache[orderId]) {
      console.log("Returning order from cache");
      orderData = orderCache[orderId];
    } else {
      console.log("Fetching order from API");
      orderData = await getSingleOrder(orderId);
      // Save fetched order to cache
      orderCache[orderId] = orderData;
    }
    console.log(orderData);
    // Update state
    this.setState({
      orderObj: orderData,
    });
  };

  render() {
    const { orderObj, loading4 } = this.state;
    const { orders, hasMore } = this.props;
    const { orderStatus } = this.props.match.params;
    let renderableOrders = orders;
    if (this.state.searchFor) {
      renderableOrders = orders.filter(
        (order) =>
          order.id
            .toString()
            .toLowerCase()
            .includes(this.state.searchFor.toLowerCase()) ||
          (order.currentUser &&
            order.currentUser.displayName
              .toLowerCase()
              .includes(this.state.searchFor.toLowerCase()))
      );
    }
    let deliveryAddress = null;
    if (
      orderObj &&
      orderObj.currentUser &&
      orderObj.currentUser.address &&
      orderObj.currentUser.address.length > 0
    ) {
      deliveryAddress = orderObj.currentUser.address.find(
        (address) => address.defaultShipping
      );
    } else if (
      orderObj &&
      orderObj.guest &&
      orderObj.guest.address &&
      orderObj.guest.address.length > 0
    ) {
      deliveryAddress = orderObj.guest.address.find(
        (address) => address.defaultShipping
      );
    }

    let totalPaid = 0;
    if (orderObj && orderObj.payments && orderObj.payments.length > 0) {
      orderObj.payments.map((payment) => {
        totalPaid += parseInt(payment.amount);
      });
    }
    let amountPayable = 0;
    if (orderObj) {
      amountPayable =
        orderObj &&
        orderObj.subTotal +
          orderObj.deliveryCharge -
          orderObj.discountApplied -
          (orderObj.couponApplied ? orderObj.couponApplied.discount : 0) -
          (orderObj.finalDiscount ? orderObj.finalDiscount : 0);
    }
    return (
      <Fragment>
        <Breadcrumb title={orderStatus} parent="Orders" />
        {loading4 && <FullPageLoader />}

        {/* <!-- Container-fluid starts--> */}
        <div className="container-fluid">
          <div className="row" style={{ justifyContent: "center" }}>
            <div className="col-sm-12">
              <div className="card">
                <div
                  className="card-header"
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    borderBottom: "1px solid gainsboro",
                  }}
                >
                  <div>
                    <h5>
                      <i
                        className="icofont-money"
                        style={{
                          fontSize: "130%",
                          marginRight: "5px",
                          color: "rgb(251, 148, 4)",
                        }}
                      ></i>
                      {orderStatus}
                    </h5>
                  </div>
                  <div
                    style={{
                      background: "#00B795",
                      color: "white",
                      padding: 10,
                      borderRadius: 10,
                      fontWeight: "bold",
                      cursor: "pointer",
                      minWidth: 200,
                      textAlign: "center",
                    }}
                    onClick={async () => {
                      console.log(this.state.balance);
                      if (!this.state.balance) {
                        console.log(this.state.balance);
                        let response = await axios.get(
                          `${base_url}/get_balance`,
                          {
                            headers: {
                              "Api-Key": api_key,
                              "Secret-Key": secret_key,
                              "Content-Type": "application/json",
                            },
                          }
                        );
                        console.log(response.data);
                        if (response.data) {
                          this.setState({
                            balance: `Tk ${response.data.current_balance}`,
                          });
                        }
                      }
                    }}
                  >
                    {this.state.balance
                      ? `${this.state.balance} `
                      : "👆🏻 Steadfast Balance"}
                  </div>
                  <li
                    style={{
                      border: "1px solid gainsboro",
                      borderRadius: "5rem",
                      padding: "0px 20px",
                      background: "whitesmoke",
                      marginRight: "20px",
                    }}
                  >
                    <form className="form-inline search-form">
                      <div
                        // className="form-group"
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-around",
                        }}
                      >
                        <input
                          className={
                            "form-control-plaintext " +
                            (this.state.searchbar ? "open" : "")
                          }
                          name="searchFor"
                          value={this.state.searchFor}
                          type="search"
                          placeholder="Search Order"
                          onChange={this.handleSearchBarChange}
                        />
                        <span>
                          <Search
                            style={{
                              marginTop: "5px",
                              borderLeft: "1px solid gainsboro",
                              paddingLeft: "7px",
                              color: "gray",
                            }}
                          />
                        </span>
                      </div>
                    </form>
                  </li>
                </div>

                <div className="card-body">
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "flex-start",
                    }}
                  >
                    <div>
                      <div
                        style={{
                          background: "#00b795",
                          color: "white",
                          fontWeight: "bold",
                          fontSize: 13,
                          padding: "10px 10px",
                          borderRadius: 5,
                          display: "inline-block",
                          textAlign: "center",
                          minWidth: 250,
                          cursor: "pointer",
                        }}
                        onClick={async () => {
                          if (this.state.loader) {
                            return;
                          }
                          this.setState({
                            loader: true,
                          });
                          let notDeliveredOrders = orders.filter(
                            (order) => order.orderStatus !== "Delivered"
                          );
                          for (let i = 0; i < notDeliveredOrders.length; i++) {
                            const order = notDeliveredOrders[i];
                            if (
                              order.courier &&
                              order.courier.consignment &&
                              order.courier.consignment.consignment_id
                            ) {
                              const response = await axios.get(
                                `${base_url}/status_by_cid/${order.courier.consignment.consignment_id}`,
                                {
                                  headers: {
                                    "Api-Key": api_key,
                                    "Secret-Key": secret_key,
                                    "Content-Type": "application/json",
                                  },
                                }
                              );
                              if (
                                response.data &&
                                response.data.delivery_status &&
                                response.data.delivery_status == "delivered"
                              ) {
                                await this.props.updateOrderRedux({
                                  ...order,
                                  orderStatus: "Delivered",
                                  [`${"Delivered".toLowerCase()}Date`]:
                                    new Date().getTime().toString(),
                                  orderStatusScore: 6,
                                });

                                await updateTransactionOrderStatus({
                                  orderId: orderObj.id,
                                  orderStatus: "Delivered",
                                });
                              }
                            }
                          }
                          this.setState({
                            loader: false,
                          });
                          toast.success(
                            "Successfully updated all order status"
                          );
                        }}
                      >
                        {this.state.loader ? (
                          <ClipLoader
                            loading={this.state.loader}
                            color="white"
                            size={14}
                          />
                        ) : (
                          "Update SteadFast Orders"
                        )}
                      </div>
                    </div>
                    <div>
                      <div
                        style={{
                          background: "#ec345b",
                          color: "white",
                          fontWeight: "bold",
                          fontSize: 13,
                          padding: "10px 10px",
                          borderRadius: 5,
                          display: "inline-block",
                          textAlign: "center",
                          minWidth: 250,
                          marginLeft: 20,
                          cursor: "pointer",
                        }}
                        onClick={async () => {
                          if (this.state.loader2) {
                            return;
                          }
                          this.setState({
                            loader2: true,
                          });
                          let notDeliveredOrders = orders.filter(
                            (order) => order.orderStatus !== "Delivered"
                          );
                          let finished = false;
                          for (let i = 0; i < notDeliveredOrders.length; i++) {
                            const order = notDeliveredOrders[i];
                            if (
                              order.courier &&
                              order.courier.pathao &&
                              order.courier.consignment_id
                            ) {
                              let baseUrl = `https://admin.zapai.com.bd`;
                              axios
                                .get(`${baseUrl}/api/issue-token`, {
                                  headers: {
                                    "Content-Type": "application/json",
                                  },
                                })
                                .then((response) => {
                                  console.log("Token Issued:", response);
                                  if (response.status == 200) {
                                    // upon getting success access_token get the city list and zone list
                                    let access_token =
                                      response.data.access_token;
                                    this.setState({
                                      access_token,
                                    });
                                    axios
                                      .get(
                                        `${baseUrl}/api/order-info/${order.courier.consignment_id}`,
                                        {
                                          headers: {
                                            "Content-Type": "application/json",
                                            Authorization: `Bearer ${access_token}`,
                                          },
                                        }
                                      )
                                      .then(async (response) => {
                                        console.log(response.data);
                                        if (
                                          response.data &&
                                          response.data.data.order_status &&
                                          response.data.order_status ==
                                            "Delivered"
                                        ) {
                                          await this.props.updateOrderRedux({
                                            ...order,
                                            orderStatus: "Delivered",
                                            [`${"Delivered".toLowerCase()}Date`]:
                                              new Date().getTime().toString(),
                                            orderStatusScore: 6,
                                          });

                                          await updateTransactionOrderStatus({
                                            orderId: orderObj.id,
                                            orderStatus: "Delivered",
                                          });
                                          console.log(
                                            notDeliveredOrders.length
                                          );
                                          if (
                                            notDeliveredOrders.length ==
                                            i + 1
                                          ) {
                                            finished = true;
                                          }
                                        }
                                        console.log(i + 1);
                                        console.log(notDeliveredOrders.length);
                                        console.log(finished);
                                      })
                                      .catch((error) => {
                                        finished = true;
                                        alert("Error getting order Info.");
                                      });
                                  }
                                })
                                .catch((error) => {
                                  finished = true;
                                  alert("Error getting access token");
                                });
                            }
                          }

                          this.setState({
                            loader2: false,
                          });

                          toast.success(
                            "Successfully updated all order status"
                          );
                        }}
                      >
                        {this.state.loader2 ? (
                          <ClipLoader
                            loading={this.state.loader2}
                            color="white"
                            size={14}
                          />
                        ) : (
                          "Update Pathao Orders"
                        )}
                      </div>
                    </div>
                  </div>
                  <span style={{ fontSize: 12, fontWeight: "bold" }}>
                    Note: click the button above to get updated shipping status
                    from steadfast or pathao
                  </span>
                  <div className="clearfix"></div>
                  <div
                    id="basicScenario"
                    className="product-physical"
                    style={{ marginTop: 20 }}
                  >
                    <table className="table table-bordered table-striped table-hover">
                      <thead>
                        <tr>
                          <th
                            scope="col"
                            style={{
                              color: "white",
                              backgroundColor: "rgb(251, 148, 4)",
                              width: "70px",
                              maxWidth: "70px",
                              textAlign: "center",
                              padding: "30px 0px",
                            }}
                          >
                            #
                          </th>
                          <th
                            scope="col"
                            style={{
                              color: "white",
                              backgroundColor: "rgb(251, 148, 4)",
                              width: "170px",
                              maxWidth: "170px",
                              textAlign: "center",
                              padding: "30px 0px",
                            }}
                          >
                            Order Id
                          </th>

                          <th
                            scope="col"
                            style={{
                              padding: "30px 5px",
                              color: "white",
                              backgroundColor: "rgb(251, 148, 4)",
                              width: "260px",
                              maxWidth: "260px",
                              minWidth: "260px",
                            }}
                          >
                            Customer
                          </th>
                          <th
                            scope="col"
                            style={{
                              color: "white",
                              backgroundColor: "rgb(251, 148, 4)",
                              width: "120px",
                              maxWidth: "120px",
                              textAlign: "center",
                              padding: "30px 0px",
                            }}
                          >
                            Products
                          </th>
                          <th
                            scope="col"
                            style={{
                              padding: "30px 15px",
                              color: "white",
                              backgroundColor: "rgb(251, 148, 4)",
                            }}
                          >
                            Order Total
                          </th>
                          <th
                            scope="col"
                            style={{
                              padding: "30px 15px",
                              color: "white",
                              backgroundColor: "rgb(251, 148, 4)",
                            }}
                          >
                            Order Status
                          </th>
                          <th
                            scope="col"
                            style={{
                              padding: "30px 15px",
                              color: "white",
                              backgroundColor: "rgb(251, 148, 4)",
                            }}
                          >
                            Payment Status
                          </th>

                          <th
                            scope="col"
                            style={{
                              padding: "30px 15px",
                              color: "white",
                              backgroundColor: "rgb(251, 148, 4)",
                            }}
                          >
                            Courier
                          </th>

                          <th
                            scope="col"
                            style={{
                              padding: "30px 15px",
                              color: "white",
                              backgroundColor: "rgb(251, 148, 4)",
                            }}
                          >
                            Invoice
                          </th>

                          <th
                            scope="col"
                            style={{
                              padding: "30px 15px",
                              color: "white",
                              backgroundColor: "rgb(251, 148, 4)",
                            }}
                          >
                            <div
                              data-toggle="modal"
                              data-target="#receiveModal"
                            >
                              Action
                            </div>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {renderableOrders.map((order, index) => (
                          <tr key={index}>
                            <th
                              scope="row"
                              style={{
                                width: "70px",
                                maxWidth: "70px",
                                textAlign: "center",
                              }}
                            >
                              {index + 1}
                            </th>
                            <td
                              scope="row"
                              style={{
                                width: "170px",
                                maxWidth: "170px",
                                textAlign: "left",
                              }}
                            >
                              <div style={{ fontWeight: "bold" }}>
                                {order.id}
                              </div>
                              <div style={{ marginTop: 5, fontSize: 13 }}>
                                {new Date(
                                  Number(order.date)
                                ).toLocaleDateString()}
                              </div>
                              <div style={{ marginTop: 5, fontSize: 13 }}>
                                at{" "}
                                {new Date(
                                  Number(order.date)
                                ).toLocaleTimeString()}
                              </div>
                            </td>

                            <td
                              style={{
                                width: "260px",
                                maxWidth: "260px",
                                minWidth: "260px",
                                textAlign: "left",
                              }}
                            >
                              <div style={{ fontWeight: "bold" }}>
                                {order.currentUser.displayName || "Guest"}
                              </div>
                              <div
                                style={{
                                  fontSize: 12,
                                  marginTop: 5,
                                  display: "flex",
                                  justifyContent: "flex-start",
                                }}
                              >
                                <div>👤</div>{" "}
                                <div style={{ marginLeft: 2 }}>
                                  {this.getDeliveryAddress(order)?.fullName}
                                </div>
                              </div>
                              <div style={{ fontSize: 12, marginTop: 5 }}>
                                📞 {this.getDeliveryAddress(order)?.mobileNo}
                              </div>
                              <div
                                style={{
                                  fontSize: 12,
                                  marginTop: 5,
                                  display: "flex",
                                  justifyContent: "flex-start",
                                }}
                              >
                                <div>🌐 </div>
                                <div
                                  style={{
                                    marginLeft: 3,
                                    lineHeight: "15px",
                                    display: "-webkit-box",
                                    WebkitLineClamp: 5, // LIMIT TO 4 LINES
                                    WebkitBoxOrient: "vertical",
                                    overflow: "hidden",
                                  }}
                                >
                                  {this.getDeliveryAddress(order)?.address},{" "}
                                  <br />
                                  {this.getDeliveryAddress(order)?.district},
                                  {this.getDeliveryAddress(order)?.division}
                                </div>
                              </div>
                              {order.orderNote && (
                                <div
                                  style={{
                                    marginTop: 10,
                                    fontSize: 11,
                                    fontWeight: "bold",
                                  }}
                                >
                                  Note:{order.orderNote}
                                </div>
                              )}
                            </td>

                            <td
                              data-toggle="modal"
                              data-target="#detailInfoModal"
                              onClick={() => {
                                this.onClick(order);
                              }}
                              style={{
                                width: "120px",
                                maxWidth: "120px",
                                textAlign: "center",
                              }}
                            >
                              <div
                                style={{
                                  color: "white",
                                  padding: "3px 10px",
                                  borderRadius: 5,
                                  backgroundColor: "cadetblue",
                                  textAlign: "center",
                                  cursor: "pointer",
                                  display: "inline-block",
                                  alignItems: "center",
                                  fontSize: 13,
                                }}
                              >
                                View
                              </div>
                            </td>

                            <td>
                              <div style={{ fontWeight: "bold" }}>
                                ৳{" "}
                                {order.subTotal +
                                  order.deliveryCharge -
                                  order.discountApplied -
                                  (order.couponApplied
                                    ? order.couponApplied.discount
                                    : 0) -
                                  (order.finalDiscount
                                    ? order.finalDiscount
                                    : 0)}
                              </div>
                              <div style={{ marginTop: 5, fontSize: 13 }}>
                                Paid: ৳ {this.getTotalPaid(order)}
                              </div>
                              <div style={{ marginTop: 5, fontSize: 13 }}>
                                COD: ৳ {this.getTotalDue(order)}
                              </div>
                            </td>

                            <td>
                              <div
                                style={{
                                  color: "white",
                                  padding: "3px 10px",
                                  borderRadius: 5,
                                  backgroundColor:
                                    order.orderStatus == "Processing"
                                      ? "#0f0fd9"
                                      : order.orderStatus == "Confirmed"
                                      ? "orange"
                                      : order.orderStatus == "Packing"
                                      ? "darkorange"
                                      : order.orderStatus == "On the way"
                                      ? "green"
                                      : order.orderStatus == "Delivered"
                                      ? "green"
                                      : "red",
                                  textAlign: "center",
                                  cursor: "pointer",
                                  display: "inline-block",
                                  fontSize: 11,
                                }}
                              >
                                {order.orderStatus}
                              </div>
                            </td>
                            <td>
                              <span
                                style={{
                                  padding: "1px 6px",
                                  fontWeight: "bold",
                                  color: "white",
                                  borderRadius: 5,
                                  background: order
                                    ? order.paymentStatus == "Partially Paid"
                                      ? "darkorange"
                                      : order.paymentStatus == "Not Paid"
                                      ? "red"
                                      : order.paymentStatus == "Paid"
                                      ? "green"
                                      : order.paymentStatus == "purchaseLater"
                                      ? "gray"
                                      : order.paymentStatus == "pending"
                                      ? "darkorange"
                                      : "red"
                                    : "red",
                                  textAlign: "center",
                                  fontSize: 11,
                                  cursor: "pointer",
                                }}
                                data-toggle="modal"
                                data-target="#paymentModal"
                                onClick={() => {
                                  this.onClick(order);
                                }}
                              >
                                {(order && order.paymentStatus) || "Not Paid"}
                              </span>
                            </td>
                            {order.orderStatus == "Processing" ||
                            order.orderStatus == "Confirmed" ? (
                              <td></td>
                            ) : (
                              <td>
                                {order.courier && order.courier.pathao ? (
                                  <div
                                    style={{
                                      display: "inline",
                                      padding: "2px 7px",
                                      borderRadius: 4,
                                      color: "white",
                                      background: "rgb(236 52 91)",
                                      cursor: "pointer",
                                      fontSize: 11,
                                    }}
                                    data-toggle="modal"
                                    data-target="#courierModal"
                                    onClick={async () => {
                                      let baseUrl = `https://admin.zapai.com.bd`;
                                      axios
                                        .get(`${baseUrl}/api/issue-token`, {
                                          headers: {
                                            "Content-Type": "application/json",
                                          },
                                        })
                                        .then((response) => {
                                          console.log(
                                            "Token Issued:",
                                            response
                                          );
                                          if (response.status == 200) {
                                            // upon getting success access_token get the city list and zone list
                                            let access_token =
                                              response.data.access_token;
                                            this.setState({
                                              access_token,
                                            });
                                            axios
                                              .get(
                                                `${baseUrl}/api/order-info/${order.courier.consignment_id}`,
                                                {
                                                  headers: {
                                                    "Content-Type":
                                                      "application/json",
                                                    Authorization: `Bearer ${access_token}`,
                                                  },
                                                }
                                              )
                                              .then((response) => {
                                                console.log(response.data);
                                                this.setState({
                                                  orderObj: {
                                                    ...order,
                                                    deliveryStatus:
                                                      response.data &&
                                                      response.data.data
                                                        .order_status
                                                        ? response.data.data
                                                            .order_status
                                                        : "",
                                                    deliveryStatusDescription: `Your Order is ${response.data.data.order_status}`,
                                                  },
                                                  orderStatus:
                                                    order.orderStatus,
                                                  courier: "Pathao",
                                                });
                                              })
                                              .catch((error) => {
                                                alert(
                                                  "Error getting order Info."
                                                );
                                              });
                                          }
                                        })
                                        .catch((error) => {
                                          alert("Error getting access token");
                                        });
                                    }}
                                  >
                                    Pathao
                                  </div>
                                ) : order.courier &&
                                  order.courier.consignment &&
                                  order.courier.consignment.consignment_id ? (
                                  <div>
                                    <div
                                      style={{
                                        display: "inline",
                                        padding: "2px 7px",
                                        borderRadius: 4,
                                        color: "white",
                                        background: "rgb(0, 183, 149)",
                                        cursor: "pointer",
                                        fontSize: 11,
                                      }}
                                      data-toggle="modal"
                                      data-target="#courierModal"
                                      onClick={async () => {
                                        await this.onClick(order);
                                        const response = await axios.get(
                                          `${base_url}/status_by_cid/${order.courier.consignment.consignment_id}`,
                                          {
                                            headers: {
                                              "Api-Key": api_key,
                                              "Secret-Key": secret_key,
                                              "Content-Type":
                                                "application/json",
                                            },
                                          }
                                        );
                                        console.log(response.data);
                                        let description = "";
                                        if (
                                          response.data &&
                                          response.data.delivery_status
                                        ) {
                                          if (
                                            response.data.delivery_status ==
                                            "pending"
                                          ) {
                                            description =
                                              "Consignment is not delivered or cancelled yet.";
                                          } else if (
                                            response.data.delivery_status ==
                                            "delivered_approval_pending"
                                          ) {
                                            description =
                                              "Consignment is delivered but waiting for admin approval.";
                                          } else if (
                                            response.data.delivery_status ==
                                            "partial_delivered_approval_pending"
                                          ) {
                                            description =
                                              "Consignment is delivered partially and waiting for admin approval.";
                                          } else if (
                                            response.data.delivery_status ==
                                            "cancelled_approval_pending"
                                          ) {
                                            description =
                                              "Consignment is cancelled and waiting for admin approval.";
                                          } else if (
                                            response.data.delivery_status ==
                                            "unknown_approval_pending"
                                          ) {
                                            description =
                                              "Unknown Pending status. Need contact with the support team.";
                                          } else if (
                                            response.data.delivery_status ==
                                            "delivered"
                                          ) {
                                            description =
                                              "Consignment is delivered and balance added.";
                                          } else if (
                                            response.data.delivery_status ==
                                            "partial_delivered"
                                          ) {
                                            description =
                                              "Consignment is partially delivered and balance added.";
                                          } else if (
                                            response.data.delivery_status ==
                                            "cancelled"
                                          ) {
                                            description =
                                              "Consignment is cancelled and balance updated.";
                                          } else if (
                                            response.data.delivery_status ==
                                            "hold"
                                          ) {
                                            description =
                                              "Consignment is held.";
                                          } else if (
                                            response.data.delivery_status ==
                                            "in_review"
                                          ) {
                                            description =
                                              "Order is placed and waiting to be reviewed.";
                                          } else if (
                                            response.data.delivery_status ==
                                            "unknown"
                                          ) {
                                            description =
                                              "Unknown status. Need contact with the support team.";
                                          }
                                        }
                                        this.setState({
                                          orderObj: {
                                            ...this.state.orderObj,
                                            deliveryStatus:
                                              response.data &&
                                              response.data.delivery_status
                                                ? response.data.delivery_status
                                                : "",
                                            deliveryStatusDescription:
                                              description,
                                          },
                                          orderStatus: order.orderStatus,
                                          courier: "SteadFast",
                                        });
                                      }}
                                    >
                                      SteadFast
                                    </div>
                                    <div
                                      style={{
                                        display: "block",
                                        marginTop: 8,
                                        fontSize: 13,
                                        fontWeight: "bold",
                                      }}
                                    >
                                      ID:
                                      {order.courier.consignment.consignment_id}
                                    </div>
                                    {/* <div
                                      style={{
                                        display: "block",
                                        marginTop: 8,
                                        fontSize: 13,
                                        fontWeight: "bold",
                                      }}
                                    >
                                      Status:
                                      <span>
                                        {order.courier.consignment.status}
                                      </span>
                                    </div> */}
                                  </div>
                                ) : order && order.courier ? (
                                  <div
                                    style={{
                                      display: "inline",
                                      padding: "2px 7px",
                                      borderRadius: 4,
                                      color: "white",
                                      background: "red",
                                      cursor: "pointer",
                                      fontSize: 13,
                                    }}
                                  >
                                    Cancelled
                                  </div>
                                ) : (
                                  <>
                                    <img
                                      data-toggle="modal"
                                      data-target="#courierModal"
                                      onClick={async () => {
                                        await this.onClick(order);
                                        this.setState({
                                          orderObj: this.state.orderObj,
                                          orderStatus: order.orderStatus,
                                          courier: "SteadFast",
                                        });
                                      }}
                                      src={SteadFast}
                                      style={{
                                        width: "80%",
                                        border: "2px solid #319f82",
                                        borderRadius: 5,
                                        cursor: "pointer",
                                      }}
                                    />{" "}
                                    <br />
                                    <img
                                      data-toggle="modal"
                                      data-target="#courierModal"
                                      onClick={async () => {
                                        await this.onClick(order);
                                        let baseUrl = `https://admin.zapai.com.bd`;
                                        axios
                                          .get(`${baseUrl}/api/issue-token`, {
                                            headers: {
                                              "Content-Type":
                                                "application/json",
                                            },
                                          })
                                          .then((response) => {
                                            console.log(
                                              "Token Issued:",
                                              response
                                            );
                                            if (response.status == 200) {
                                              // upon getting success access_token get the city list and zone list
                                              let access_token =
                                                response.data.access_token;
                                              this.setState({
                                                access_token,
                                              });
                                              axios
                                                .get(
                                                  `${baseUrl}/api/city-list`,
                                                  {
                                                    headers: {
                                                      "Content-Type":
                                                        "application/json",
                                                      Authorization: `Bearer ${access_token}`,
                                                    },
                                                  }
                                                )
                                                .then((response) => {
                                                  //  upon getting city lists find the actual city.

                                                  this.setState(
                                                    {
                                                      cityList:
                                                        response.data.data.data,
                                                    },
                                                    () => {
                                                      console.log(
                                                        this.state.cityList
                                                      );
                                                    }
                                                  );
                                                })
                                                .catch((error) => {
                                                  alert(error);
                                                });
                                            }
                                          })
                                          .catch((error) => {
                                            alert(
                                              "Error creating access token. "
                                            );
                                            console.error(
                                              "Error:",
                                              error.response
                                                ? error.response.data
                                                : error.message
                                            );
                                          });
                                        this.setState({
                                          orderStatus: order.orderStatus,
                                          courier: "Pathao",
                                          note: "",
                                          weight: "",
                                          city: null,
                                          cityList: [],
                                          areaList: [],
                                          cityObject: null,
                                          zoneObject: null,
                                          zone: null,
                                        });
                                      }}
                                      src={Pathao}
                                      style={{
                                        width: "80%",
                                        border: "2px solid #ec345b",
                                        borderRadius: 5,
                                        cursor: "pointer",
                                      }}
                                    />
                                  </>
                                )}
                              </td>
                            )}
                            <td>
                              <a
                                style={{
                                  color: "white",
                                  padding: "3px 10px",
                                  borderRadius: 5,
                                  backgroundColor: "black",
                                  textAlign: "center",
                                  cursor: "pointer",
                                  display: "inline-block",
                                  fontSize: 12,
                                  fontWeight: "bold",
                                }}
                                href={`https://zapai.com.bd/invoice?orderId=${order.id}`}
                                target="_blank"
                              >
                                invoice
                              </a>
                              {this.props.currentAdmin &&
                                this.props.currentAdmin.status !=
                                  "Employee" && (
                                  <span
                                    style={{
                                      color: "white",
                                      padding: "3px 10px",
                                      borderRadius: 5,
                                      backgroundColor: "darkorange",
                                      textAlign: "center",
                                      cursor: "pointer",
                                      display: "inline-block",
                                      fontSize: 12,
                                      fontWeight: "bold",
                                      marginLeft: 5,
                                    }}
                                    data-toggle="modal"
                                    data-target="#personalInfoModal2"
                                    onClick={async () => {
                                      await this.onClick(order);
                                      this.setState({
                                        orderStatus: order.orderStatus,
                                      });
                                    }}
                                  >
                                    edit
                                  </span>
                                )}
                            </td>

                            {order && order.orderStatus == "Delivered" ? (
                              ""
                            ) : (
                              <td>
                                <div
                                  className="row"
                                  style={{ justifyContent: "center" }}
                                >
                                  <i
                                    className="icofont-edit"
                                    data-toggle="modal"
                                    data-target="#personalInfoModal"
                                    onClick={async () => {
                                      await this.onClick(order);
                                      this.setState({
                                        orderStatus: order.orderStatus,
                                      });
                                    }}
                                    style={{
                                      color: "green",
                                      marginRight: 8,
                                      cursor: "pointer",
                                    }}
                                  />
                                </div>
                                <div
                                  style={{
                                    marginTop: 10,
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "center",
                                  }}
                                >
                                  <span
                                    style={{
                                      color: "white",
                                      padding: "2px 7px",
                                      borderRadius: 5,
                                      backgroundColor: "darkgreen",
                                      textAlign: "center",
                                      cursor: "pointer",
                                      display: "inline",
                                      fontSize: 11,
                                      fontWeight: "bold",
                                    }}
                                    onClick={async () => {
                                      await this.onClick(order);
                                      this.setState(
                                        { orderObj: this.state.orderObj },
                                        () => {
                                          // call handlePrint from the ref

                                          this.reactToPrintTrigger.handlePrint();
                                        }
                                      );
                                    }}
                                  >
                                    Print
                                  </span>
                                </div>
                              </td>
                            )}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer />
        {/* <!-- Container-fluid Ends--> */}
        <div
          className="modal fade"
          id="personalInfoModal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div
            className="modal-dialog"
            role="document"
            style={{ margin: "auto" }}
          >
            <div
              className="modal-content"
              style={{ top: 10, width: "100%", margin: "auto" }}
            >
              <div
                className="modal-header"
                style={{
                  backgroundColor: "rgb(251, 148, 4)",
                  paddingTop: 20,
                  paddingBottom: 20,
                }}
              >
                <div
                  className="modal-title"
                  style={{
                    fontWeight: "bold",
                    fontSize: 17,
                    color: "white",
                  }}
                  id="exampleModalLabel"
                >
                  Update Status
                </div>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  id="personal-info-close"
                >
                  <span aria-hidden="true" style={{ color: "white" }}>
                    &times;
                  </span>
                </button>
              </div>
              {orderObj && (
                <div className="modal-body">
                  <div style={{ padding: "10px 15px" }}>
                    <div className="form-group">
                      <label
                        style={{
                          fontWeight: "bold",
                          color: "#505050",
                          marginBottom: 5,
                        }}
                      >
                        Status
                      </label>
                      <select
                        title="Please choose a package"
                        required
                        name="orderStatus"
                        className="custom-select"
                        aria-required="true"
                        aria-invalid="false"
                        onChange={this.handleChange}
                        value={this.state.orderStatus}
                      >
                        <option value="">Select Status</option>
                        <option value="Processing">Processing</option>
                        <option
                          value="Confirmed"
                          disabled={orderObj.date ? false : true}
                        >
                          Confirmed
                        </option>
                        <option
                          value="Packing"
                          disabled={orderObj.confirmedDate ? false : true}
                        >
                          Packing
                        </option>
                        <option
                          value="On the way"
                          disabled={orderObj.packingDate ? false : true}
                        >
                          On the way
                        </option>
                        <option
                          value="Delivered"
                          disabled={orderObj["on the wayDate"] ? false : true}
                        >
                          Delivered
                        </option>
                        <option
                          value="Partial Delivered"
                          disabled={orderObj["on the wayDate"] ? false : true}
                        >
                          Partial Delivered
                        </option>
                        <option value="Cancelled"> Cancelled</option>
                      </select>
                    </div>

                    {this.state.orderStatus == "Cancelled" && (
                      <div className="form-group">
                        <label
                          style={{
                            fontWeight: "bold",
                            color: "#505050",
                            marginBottom: 5,
                          }}
                        >
                          Cancellation note
                        </label>
                        <textarea
                          type="text"
                          name="cancelNote"
                          className="form-control"
                          placeholder="Enter Cancellation Note"
                          style={{ fontSize: "1rem" }}
                          onChange={this.handleChange}
                          value={this.state.cancelNote}
                        />
                      </div>
                    )}
                  </div>
                </div>
              )}
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn "
                  data-dismiss="modal"
                  style={{
                    backgroundColor: "darkorange",
                    color: "white",
                    padding: 8,
                    borderRadius: 5,
                    fontWeight: "lighter",
                  }}
                  onClick={() => {
                    this.handleSubmit();
                  }}
                >
                  Update
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal fade"
          id="personalInfoModal2"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div
            className="modal-dialog"
            role="document"
            style={{ margin: "auto" }}
          >
            <div
              className="modal-content"
              style={{ top: 10, width: "100%", margin: "auto" }}
            >
              <div
                className="modal-header"
                style={{
                  backgroundColor: "rgb(251, 148, 4)",
                  paddingTop: 20,
                  paddingBottom: 20,
                }}
              >
                <div
                  className="modal-title"
                  style={{
                    fontWeight: "bold",
                    fontSize: 17,
                    color: "white",
                  }}
                  id="exampleModalLabel"
                >
                  Edit Order
                </div>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  id="personal-info-close"
                >
                  <span aria-hidden="true" style={{ color: "white" }}>
                    &times;
                  </span>
                </button>
              </div>
              {orderObj && (
                <div className="modal-body">
                  <div style={{ padding: "10px 15px" }}>
                    {orderObj && (
                      <section className="flat-spacing-11">
                        <div className="tf-page-cart-wrap">
                          <div className="tf-page-cart-item">
                            <form onSubmit={(e) => e.preventDefault()}>
                              {orderObj.orders.map((item, i) => (
                                <div
                                  key={i}
                                  className="tf-cart-item file-delete"
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "space-between",
                                    marginBottom: 10,
                                    paddingBottom: 10,
                                    borderBottom: "1px solid gainsboro",
                                  }}
                                >
                                  <div
                                    className="tf-cart-item_product"
                                    style={{
                                      display: "flex",
                                      flexDirection: "row",
                                      justifyContent: "flex-start",
                                    }}
                                  >
                                    <div className="img-box fixed-width-height">
                                      <img
                                        alt="img-product"
                                        src={
                                          item.selectedVariation &&
                                          item.selectedVariation.id &&
                                          item.selectedVariation.pictures &&
                                          item.selectedVariation.pictures
                                            .length > 0
                                            ? item.selectedVariation.pictures[0]
                                            : item.product.pictures[0]
                                        }
                                        style={{
                                          objectFit: "cover",
                                          borderRadius: 5,
                                          border: "1px solid gainsboro",
                                          maxHeight: 70,
                                          minHeight: 70,
                                          maxWidth: 70,
                                          minWidth: 70,
                                        }}
                                      />
                                    </div>
                                    <div
                                      className="cart-info"
                                      style={{ marginLeft: 5 }}
                                    >
                                      <div className="cart-title link">
                                        <div
                                          style={{
                                            fontWeight: "bold",
                                            fontSize: 13,
                                          }}
                                        >
                                          {item.product.name.slice(0, 40)}
                                        </div>
                                      </div>
                                      <div
                                        className="cart-meta-variant"
                                        style={{
                                          fontSize: 13,
                                          marginTop: 5,
                                        }}
                                      >
                                        {item.selectedVariation &&
                                          item.selectedVariation.id &&
                                          item.selectedVariation.combination.map(
                                            (comb, index) => (
                                              <div
                                                key={index}
                                                style={{
                                                  marginTop: -5,
                                                }}
                                              >
                                                {item.product.savedAttributes.find(
                                                  (attr) =>
                                                    attr.id == comb.parentId
                                                )
                                                  ? item.product.savedAttributes.find(
                                                      (attr) =>
                                                        attr.id == comb.parentId
                                                    ).name
                                                  : ""}
                                                :{" "}
                                                <span
                                                  style={{
                                                    fontWeight: "bold",
                                                    fontSize: 13,
                                                  }}
                                                >
                                                  {comb.name}
                                                </span>
                                              </div>
                                            )
                                          )}
                                      </div>
                                      <div
                                        className="tf-cart-item_quantity"
                                        cart-data-title="Quantity"
                                      >
                                        <div className="cart-quantity">
                                          <div
                                            className="wg-quantity"
                                            style={{ marginBottom: 10 }}
                                          >
                                            <span
                                              className="btn-quantity minus-btn"
                                              onClick={() => {
                                                let orders =
                                                  orderObj.orders.map(
                                                    (cartItem) => {
                                                      if (
                                                        item.selectedVariation &&
                                                        item.selectedVariation
                                                          .id
                                                      ) {
                                                        if (
                                                          cartItem.selectedVariation &&
                                                          cartItem
                                                            .selectedVariation
                                                            .id ==
                                                            item
                                                              .selectedVariation
                                                              .id
                                                        ) {
                                                          return {
                                                            ...cartItem,
                                                            quantity:
                                                              cartItem.quantity >
                                                              1
                                                                ? parseInt(
                                                                    cartItem.quantity
                                                                  ) - 1
                                                                : 1,
                                                          };
                                                        } else {
                                                          return cartItem;
                                                        }
                                                      } else {
                                                        if (
                                                          cartItem.productId ==
                                                          item.productId
                                                        ) {
                                                          return {
                                                            ...cartItem,
                                                            quantity:
                                                              cartItem.quantity >
                                                              1
                                                                ? parseInt(
                                                                    cartItem.quantity
                                                                  ) - 1
                                                                : 1,
                                                          };
                                                        } else {
                                                          return cartItem;
                                                        }
                                                      }
                                                    }
                                                  );
                                                let { actualOrder, sumAmount } =
                                                  this.calculateCart(orders);
                                                console.log(actualOrder);
                                                console.log(sumAmount);
                                                this.setState({
                                                  orderObj: {
                                                    ...orderObj,
                                                    orders: orders,
                                                    discountApplied:
                                                      actualOrder - sumAmount,
                                                    subTotal: actualOrder,
                                                  },
                                                });
                                              }}
                                              style={{
                                                background: "darkorange",
                                                color: "white",
                                                padding: "4px 8px",
                                                borderBottomLeftRadius: 5,
                                                borderTopLeftRadius: 5,
                                              }}
                                            >
                                              <svg
                                                className="d-inline-block"
                                                width={9}
                                                height={9}
                                                viewBox="0 0 9 1"
                                                fill="currentColor"
                                              >
                                                <path d="M9 1H5.14286H3.85714H0V1.50201e-05H3.85714L5.14286 0L9 1.50201e-05V1Z" />
                                              </svg>
                                            </span>
                                            <input
                                              type="text"
                                              name="number"
                                              value={item.quantity}
                                              min={1}
                                              style={{
                                                maxWidth: 50,
                                                textAlign: "center",
                                                marginTop: 10,
                                                color: "gray",
                                                borderLeft: "none",
                                                borderRight: "none",
                                                padding: 2,
                                              }}
                                              onChange={(e) => {
                                                let orders =
                                                  orderObj.orders.map(
                                                    (cartItem) => {
                                                      if (
                                                        item.selectedVariation &&
                                                        item.selectedVariation
                                                          .id
                                                      ) {
                                                        if (
                                                          cartItem.selectedVariation &&
                                                          cartItem
                                                            .selectedVariation
                                                            .id ==
                                                            item
                                                              .selectedVariation
                                                              .id
                                                        ) {
                                                          return {
                                                            ...cartItem,
                                                            quantity:
                                                              e.target.value &&
                                                              e.target.value > 0
                                                                ? parseInt(
                                                                    e.target
                                                                      .value
                                                                  )
                                                                : cartItem.quantity,
                                                          };
                                                        } else {
                                                          return cartItem;
                                                        }
                                                      } else {
                                                        if (
                                                          cartItem.productId ==
                                                          item.productId
                                                        ) {
                                                          return {
                                                            ...cartItem,
                                                            quantity:
                                                              e.target.value &&
                                                              e.target.value > 0
                                                                ? parseInt(
                                                                    e.target
                                                                      .value
                                                                  )
                                                                : cartItem.quantity,
                                                          };
                                                        } else {
                                                          return cartItem;
                                                        }
                                                      }
                                                    }
                                                  );
                                                let { actualOrder, sumAmount } =
                                                  this.calculateCart(orders);
                                                console.log(actualOrder);
                                                console.log(sumAmount);
                                                this.setState({
                                                  orderObj: {
                                                    ...orderObj,
                                                    orders: orders,
                                                    discountApplied:
                                                      actualOrder - sumAmount,
                                                    subTotal: actualOrder,
                                                  },
                                                });
                                              }}
                                            />
                                            <span
                                              className="btn-quantity plus-btn"
                                              onClick={() => {
                                                let orders =
                                                  orderObj.orders.map(
                                                    (cartItem) => {
                                                      if (
                                                        item.selectedVariation &&
                                                        item.selectedVariation
                                                          .id
                                                      ) {
                                                        if (
                                                          cartItem.selectedVariation
                                                        ) {
                                                          if (
                                                            cartItem
                                                              .selectedVariation
                                                              .id ===
                                                            item
                                                              .selectedVariation
                                                              .id
                                                          ) {
                                                            console.log(
                                                              cartItem
                                                            );

                                                            return {
                                                              ...cartItem,
                                                              quantity:
                                                                parseInt(
                                                                  cartItem.quantity
                                                                ) + 1,
                                                            };
                                                          } else {
                                                            return cartItem;
                                                          }
                                                        } else {
                                                          return cartItem;
                                                        }
                                                      } else {
                                                        if (
                                                          cartItem.productId ==
                                                          item.productId
                                                        ) {
                                                          return {
                                                            ...cartItem,
                                                            quantity:
                                                              parseInt(
                                                                cartItem.quantity
                                                              ) + 1,
                                                          };
                                                        } else {
                                                          return cartItem;
                                                        }
                                                      }
                                                    }
                                                  );
                                                let { actualOrder, sumAmount } =
                                                  this.calculateCart(orders);
                                                console.log(actualOrder);
                                                console.log(sumAmount);
                                                this.setState({
                                                  orderObj: {
                                                    ...orderObj,
                                                    orders: orders,
                                                    discountApplied:
                                                      actualOrder - sumAmount,
                                                    subTotal: actualOrder,
                                                  },
                                                });
                                              }}
                                              style={{
                                                background: "darkorange",
                                                color: "white",
                                                padding: "4px 8px",
                                                borderBottomRightRadius: 5,
                                                borderTopRightRadius: 5,
                                              }}
                                            >
                                              <svg
                                                className="d-inline-block"
                                                width={9}
                                                height={9}
                                                viewBox="0 0 9 9"
                                                fill="currentColor"
                                              >
                                                <path d="M9 5.14286H5.14286V9H3.85714V5.14286H0V3.85714H3.85714V0H5.14286V3.85714H9V5.14286Z" />
                                              </svg>
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                      <span
                                        className="remove-cart link remove"
                                        onClick={() => {
                                          let updatedOrderArray = [];
                                          console.log(orderObj);
                                          if (orderObj.orders.length == 1) {
                                            alert(
                                              "Order at least must have one item."
                                            );
                                            return;
                                          }
                                          if (item.selectedVariation) {
                                            // Remove the item with the matching productId and selectedVariation
                                            const updatedOrder =
                                              orderObj.orders.filter(
                                                (order) =>
                                                  !(
                                                    order.productId ===
                                                      item.productId &&
                                                    order.selectedVariation
                                                      ?.id ===
                                                      item.selectedVariation.id
                                                  )
                                              );

                                            // Update localStorage

                                            updatedOrderArray = updatedOrder;
                                          } else {
                                            // Remove the item with the matching productId
                                            const updatedOrder =
                                              orderObj.orders.filter(
                                                (order) =>
                                                  order.productId !==
                                                  item.productId
                                              );
                                            updatedOrderArray = updatedOrder;
                                          }
                                          console.log(updatedOrderArray);
                                          let { actualOrder, sumAmount } =
                                            this.calculateCart(
                                              updatedOrderArray
                                            );
                                          console.log(sumAmount);
                                          this.setState(
                                            {
                                              orderObj: {
                                                ...this.state.orderObj,
                                                orders: updatedOrderArray,
                                                discountApplied:
                                                  actualOrder - sumAmount,
                                                subTotal: actualOrder,
                                              },
                                            },
                                            () => {
                                              console.log(this.state.orderObj);
                                            }
                                          );
                                        }}
                                        style={{
                                          textDecoration: "underline",
                                          fontSize: 13,
                                          cursor: "pointer",
                                        }}
                                      >
                                        Remove
                                      </span>
                                    </div>
                                  </div>
                                  <div
                                    className="tf-cart-item_price"
                                    cart-data-title="Price"
                                  >
                                    <div
                                      className="price fw-6"
                                      style={{
                                        textAlign: "center",
                                        marginTop: 3,
                                        fontSize: 14,
                                        fontWeight: "bold",
                                      }}
                                    >
                                      ৳ {this.getPrice2(item)}
                                    </div>
                                    <div
                                      className="price fw-6"
                                      style={{
                                        textAlign: "center",
                                        textDecoration: "line-through",
                                        color: "gray",
                                        fontSize: 11,
                                      }}
                                    >
                                      {this.getPrice3(item)}
                                    </div>
                                    <div
                                      className="tf-cart-item_total"
                                      cart-data-title="Total"
                                      style={{ marginTop: 20 }}
                                    >
                                      <div
                                        className="cart-total"
                                        style={{
                                          minWidth: "60px",
                                          textAlign: "center",
                                          fontWeight: "bold",
                                        }}
                                      >
                                        ৳{this.singleProductTotal(item)}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ))}
                              {orderObj &&
                                orderObj.couponApplied &&
                                orderObj.couponApplied.name && (
                                  <div className="form-group">
                                    <span
                                      style={{
                                        display: "flex",
                                        flexDirection: "row",
                                      }}
                                    >
                                      <input
                                        type="checkbox"
                                        name={""}
                                        checked={false}
                                        onChange={(e) => {
                                          this.setState({
                                            orderObj: {
                                              ...this.state.orderObj,
                                              couponApplied: e.target.checked
                                                ? null
                                                : orderObj.couponApplied,
                                            },
                                          });
                                        }}
                                        style={{
                                          height: 20,
                                          width: 20,
                                        }}
                                      />

                                      <div
                                        style={{
                                          marginLeft: 5,
                                          color: "black",
                                          fontWeight: "bold",
                                          marginTop: 2,
                                        }}
                                      >
                                        Remove Coupon
                                      </div>
                                    </span>
                                  </div>
                                )}
                              <div
                                className="form-group"
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  justifyContent: "space-between",
                                }}
                              >
                                <label
                                  style={{
                                    fontWeight: "bold",
                                    color: "black",
                                    marginTop: 14,
                                  }}
                                >
                                  Update delivery charge
                                </label>
                                <input
                                  type="number"
                                  name="number"
                                  value={
                                    orderObj && orderObj.deliveryCharge > 0
                                      ? orderObj.deliveryCharge
                                      : ""
                                  }
                                  style={{
                                    textAlign: "center",
                                    marginTop: 10,
                                    color: "gray",
                                    padding: 2,
                                    paddingLeft: 5,
                                    border: "2px solid gray",
                                    borderRadius: 5,
                                  }}
                                  onChange={(e) => {
                                    // Ensure we update only if the input is a valid number
                                    if (e.target.value && e.target.value >= 0) {
                                      this.setState({
                                        orderObj: {
                                          ...orderObj,
                                          deliveryCharge:
                                            e.target.value === ""
                                              ? ""
                                              : parseInt(e.target.value), // If empty, don't set a value
                                        },
                                      });
                                    }
                                  }}
                                />
                              </div>
                              <div
                                className="form-group"
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  justifyContent: "space-between",
                                }}
                              >
                                <label
                                  style={{
                                    fontWeight: "bold",
                                    color: "black",
                                    marginTop: 14,
                                  }}
                                >
                                  Final Discount
                                </label>
                                <input
                                  type="number"
                                  name="number"
                                  value={
                                    orderObj && orderObj.finalDiscount > 0
                                      ? orderObj.finalDiscount
                                      : ""
                                  }
                                  style={{
                                    textAlign: "center",
                                    marginTop: 10,
                                    color: "gray",
                                    padding: 2,
                                    paddingLeft: 5,
                                    border: "2px solid gray",
                                    borderRadius: 5,
                                  }}
                                  onChange={(e) => {
                                    // Ensure we update only if the input is a valid number
                                    if (e.target.value && e.target.value >= 0) {
                                      this.setState({
                                        orderObj: {
                                          ...orderObj,
                                          finalDiscount:
                                            e.target.value === ""
                                              ? ""
                                              : parseInt(e.target.value), // If empty, don't set a value
                                        },
                                      });
                                    }
                                  }}
                                />
                              </div>
                            </form>
                          </div>
                          {orderObj && (
                            <div className="tf-page-cart-footer">
                              <div
                                className="tf-cart-totals-discounts"
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  justifyContent: "space-between",
                                }}
                              >
                                <h3
                                  style={{ fontWeight: "bold", color: "black" }}
                                >
                                  Delivery Charge{" "}
                                </h3>
                                <span
                                  className="total-value"
                                  style={{
                                    fontWeight: "bold",
                                    marginRight: 10,
                                  }}
                                >
                                  ৳{" "}
                                  {(orderObj && orderObj.deliveryCharge) || "0"}
                                </span>
                              </div>
                              <div
                                className="tf-cart-totals-discounts"
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  justifyContent: "space-between",
                                }}
                              >
                                <h3
                                  style={{ fontWeight: "bold", color: "black" }}
                                >
                                  Discount applied{" "}
                                </h3>
                                <span
                                  className="total-value"
                                  style={{
                                    fontWeight: "bold",
                                    marginRight: 10,
                                  }}
                                >
                                  ৳{" "}
                                  {(orderObj && orderObj.discountApplied) ||
                                    "0"}
                                </span>
                              </div>
                              <div
                                className="tf-cart-totals-discounts"
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  justifyContent: "space-between",
                                }}
                              >
                                <h3
                                  style={{ fontWeight: "bold", color: "black" }}
                                >
                                  Coupon applied{" "}
                                  <span
                                    style={{
                                      color: "rgb(251, 148, 4)",
                                      fontWeight: "bold",
                                      fontSize: 12,
                                    }}
                                  >
                                    {" "}
                                    (
                                    {orderObj.couponApplied &&
                                      orderObj.couponApplied.name}
                                    )
                                  </span>
                                </h3>
                                <span
                                  className="total-value"
                                  style={{
                                    fontWeight: "bold",
                                    marginRight: 10,
                                  }}
                                >
                                  ৳{" "}
                                  {(orderObj.couponApplied &&
                                    orderObj.couponApplied.discount) ||
                                    0}
                                </span>
                              </div>
                              <div
                                className="tf-cart-totals-discounts"
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  justifyContent: "space-between",
                                }}
                              >
                                <h3
                                  style={{ fontWeight: "bold", color: "black" }}
                                >
                                  Subtotal
                                </h3>
                                <span
                                  className="total-value"
                                  style={{
                                    fontWeight: "bold",
                                    marginRight: 10,
                                  }}
                                >
                                  ৳{" "}
                                  {parseInt(orderObj.subTotal) +
                                    orderObj.deliveryCharge -
                                    orderObj.discountApplied -
                                    (orderObj.couponApplied
                                      ? orderObj.couponApplied.discount
                                      : 0)}
                                </span>
                              </div>
                              <div
                                className="tf-cart-totals-discounts"
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  justifyContent: "space-between",
                                }}
                              >
                                <h3
                                  style={{ fontWeight: "bold", color: "black" }}
                                >
                                  Final Discount{" "}
                                </h3>
                                <span
                                  className="total-value"
                                  style={{
                                    fontWeight: "bold",
                                    marginRight: 10,
                                  }}
                                >
                                  - ৳{" "}
                                  {(orderObj.finalDiscount &&
                                    orderObj.finalDiscount) ||
                                    0}
                                </span>
                              </div>
                              <div
                                className="tf-cart-totals-discounts"
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  justifyContent: "space-between",
                                }}
                              >
                                <h3
                                  style={{ fontWeight: "bold", color: "black" }}
                                >
                                  Payable Amount{" "}
                                  <span style={{ fontSize: 11 }}>
                                    (after discount)
                                  </span>
                                </h3>
                                <span
                                  className="total-value"
                                  style={{
                                    fontWeight: "bold",
                                    marginRight: 10,
                                  }}
                                >
                                  ৳{" "}
                                  {parseInt(orderObj.subTotal) +
                                    orderObj.deliveryCharge -
                                    orderObj.discountApplied -
                                    (orderObj.couponApplied
                                      ? orderObj.couponApplied.discount
                                      : 0) -
                                    (orderObj.finalDiscount
                                      ? orderObj.finalDiscount
                                      : 0)}
                                </span>
                              </div>
                            </div>
                          )}
                        </div>
                      </section>
                    )}
                  </div>
                </div>
              )}
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn "
                  data-dismiss="modal"
                  style={{
                    backgroundColor: "darkorange",
                    color: "white",
                    padding: 8,
                    borderRadius: 5,
                    fontWeight: "lighter",
                  }}
                  onClick={() => {
                    this.updateOrder();
                  }}
                >
                  Update Order
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal fade"
          id="courierModal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div
            className="modal-dialog"
            role="document"
            style={{ margin: "auto" }}
          >
            <div
              className="modal-content"
              style={{ top: 10, width: "100%", margin: "auto" }}
            >
              <div
                className="modal-header"
                style={{
                  backgroundColor: "rgb(251, 148, 4)",
                  paddingTop: 20,
                  paddingBottom: 20,
                }}
              >
                <div
                  className="modal-title"
                  style={{
                    fontWeight: "bold",
                    fontSize: 17,
                    color: "white",
                  }}
                  id="exampleModalLabel"
                >
                  {orderObj &&
                  orderObj.courier &&
                  orderObj.courier.pathao &&
                  orderObj.courier.consignment_id
                    ? "Consignment has been created at pathao"
                    : orderObj &&
                      orderObj.courier &&
                      orderObj.courier.status == 200
                    ? "Consignment has been created at steadFast"
                    : orderObj &&
                      orderObj.courier &&
                      orderObj.courier.status != 200
                    ? "An error occurred creating the consignment."
                    : "Select Courier"}
                </div>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  id="close-btn-courier"
                >
                  <span aria-hidden="true" style={{ color: "white" }}>
                    &times;
                  </span>
                </button>
              </div>
              {orderObj && (
                <div className="modal-body">
                  <div style={{ padding: "10px 15px" }}>
                    <div className="form-group">
                      {!orderObj.courier && (
                        <div>
                          Are you sure you want to deliver this order with{" "}
                          {this.state.courier}?
                        </div>
                      )}
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "flex-start",
                          marginTop: 20,
                        }}
                      >
                        <div style={{ fontWeight: "bold", marginTop: 10 }}>
                          {" "}
                          Selected Courier:{" "}
                        </div>
                        <img
                          src={
                            this.state.courier == "SteadFast"
                              ? SteadFast
                              : Pathao
                          }
                          style={{
                            width: 100,
                            marginLeft: 6,
                            border:
                              this.state.courier == "SteadFast"
                                ? "2px solid #319f82"
                                : "2px solid #e83234",
                            borderRadius: 5,
                          }}
                        />
                      </div>
                      {!orderObj.courier && (
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "flex-start",
                            marginTop: 20,
                          }}
                        >
                          <div style={{ minWidth: "100%" }}>
                            {this.state.courier === "Pathao" && (
                              <>
                                <div
                                  // className="form-group"
                                  style={{ minWidth: "100%" }}
                                >
                                  <div style={{ fontWeight: "bold" }}>
                                    Total Weight (in kg)
                                  </div>
                                  <input
                                    name="weight"
                                    value={this.state.weight}
                                    style={{
                                      width: "100%",
                                      borderRadius: 5,
                                      textAlign: "left",
                                      marginTop: 5,
                                      padding: 10,
                                    }}
                                    type="number"
                                    placeholder="Enter Product weight (in kg)"
                                    onChange={(e) => {
                                      this.setState({
                                        weight: e.target.value,
                                      });
                                    }}
                                  />
                                </div>
                                <div
                                  // className="form-group"
                                  style={{ minWidth: "100%", marginTop: 15 }}
                                >
                                  <div style={{ fontWeight: "bold" }}>
                                    Select City
                                  </div>
                                  <select
                                    title=""
                                    name="city"
                                    className="custom-select"
                                    aria-required="true"
                                    aria-invalid="false"
                                    onChange={async (e) => {
                                      const { name, value } = e.target;
                                      let cityObject = this.state.cityList.find(
                                        (city) => city.city_name == value
                                      );
                                      console.log(this.state.cityList);
                                      console.log(value);
                                      console.log(cityObject);
                                      this.setState(
                                        {
                                          [name]: value,
                                          cityObject: this.state.cityList.find(
                                            (city) => city.city_name == value
                                          ),
                                        },
                                        async () => {
                                          let baseUrl = `https://admin.zapai.com.bd`;
                                          axios
                                            .get(
                                              `${baseUrl}/api/get-zone-list/${this.state.cityObject.city_id}`,
                                              {
                                                headers: {
                                                  "Content-Type":
                                                    "application/json",
                                                  Authorization: `Bearer ${this.state.access_token}`,
                                                },
                                              }
                                            )
                                            .then((response) => {
                                              console.log(response);
                                              this.setState({
                                                areaList:
                                                  response.data.data.data,
                                              });
                                            })
                                            .catch((error) => {
                                              console.log(error);
                                            });
                                        }
                                      );
                                    }}
                                    style={{ fontSize: ".8rem" }}
                                    value={this.state.city}
                                    required
                                  >
                                    <option value="">Select City</option>
                                    {this.state.cityList.map((city) => {
                                      return (
                                        <option value={city.city_name}>
                                          {city.city_name}
                                        </option>
                                      );
                                    })}
                                  </select>
                                </div>
                                <div
                                  // className="form-group"
                                  style={{ minWidth: "100%", marginTop: 15 }}
                                >
                                  <div style={{ fontWeight: "bold" }}>
                                    Select Zone
                                  </div>
                                  <select
                                    title=""
                                    name="zone"
                                    className="custom-select"
                                    aria-required="true"
                                    aria-invalid="false"
                                    onChange={(e) => {
                                      const { name, value } = e.target;
                                      this.setState({
                                        [name]: value,
                                        zoneObject: this.state.areaList.find(
                                          (area) => area.zone_name == value
                                        ),
                                      });
                                    }}
                                    style={{ fontSize: ".8rem" }}
                                    value={this.state.zone}
                                    required
                                  >
                                    {this.state.cityObject &&
                                    this.state.areaList.length > 0 ? (
                                      <>
                                        <option value="">Select Area</option>
                                        {this.state.areaList.map((area) => {
                                          return (
                                            <option value={area.zone_name}>
                                              {area.zone_name}
                                            </option>
                                          );
                                        })}
                                      </>
                                    ) : (
                                      <option value="">
                                        Select City first
                                      </option>
                                    )}
                                  </select>
                                </div>
                              </>
                            )}

                            <div
                              // className="form-group"
                              style={{ minWidth: "100%", marginTop: 15 }}
                            >
                              <div style={{ fontWeight: "bold" }}>
                                Write Delivery Instruction
                              </div>
                              <textarea
                                name="note"
                                value={this.state.note}
                                style={{
                                  width: "100%",
                                  height: 200,
                                  border: "1px solid gainsboro",
                                  borderRadius: 5,
                                  textAlign: "left",
                                  marginTop: 5,
                                  padding: 10,
                                }}
                                type="search"
                                placeholder="Wrtie delivery instruction to courier partner"
                                onChange={(e) => {
                                  this.setState({
                                    note: e.target.value,
                                  });
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      )}
                      <div
                        style={{
                          marginTop: 30,
                          fontWeight: "bold",
                          marginBottom: 6,
                        }}
                      >
                        Courier Information
                      </div>
                      {orderObj &&
                        orderObj.courier &&
                        orderObj.courier.pathao && (
                          <div style={{ marginTop: 5 }}>
                            Consignment Id:{" "}
                            <span style={{ fontWeight: "bold" }}>
                              {orderObj.courier.consignment_id}
                            </span>
                          </div>
                        )}{" "}
                      {orderObj &&
                        orderObj.courier &&
                        orderObj.courier.pathao && (
                          <div style={{ marginTop: 5 }}>
                            Delivery Fee:{" "}
                            <span style={{ fontWeight: "bold" }}>
                              {orderObj.courier.delivery_fee}Tk
                            </span>
                          </div>
                        )}
                      {orderObj &&
                        orderObj.courier &&
                        orderObj.courier.pathao && (
                          <div style={{ marginTop: 5 }}>
                            City (for pathao booking):{" "}
                            <span style={{ fontWeight: "bold" }}>
                              {orderObj.courier.city.city_name}
                            </span>
                          </div>
                        )}
                      {orderObj &&
                        orderObj.courier &&
                        orderObj.courier.pathao && (
                          <div style={{ marginTop: 5 }}>
                            Zone (for pathao booking):{" "}
                            <span style={{ fontWeight: "bold" }}>
                              {orderObj.courier.zone.zone_name}
                            </span>
                          </div>
                        )}
                      {orderObj &&
                        orderObj.courier &&
                        orderObj.courier.pathao && (
                          <div style={{ marginTop: 5 }}>
                            Parcel weight (for pathao booking):{" "}
                            <span style={{ fontWeight: "bold" }}>
                              {orderObj.courier.weight}kg
                            </span>
                          </div>
                        )}
                      {orderObj &&
                        orderObj.courier &&
                        orderObj.courier.consignment && (
                          <div style={{ marginTop: 5 }}>
                            Created At:{" "}
                            <span style={{ fontWeight: "bold" }}>
                              {new Date(
                                orderObj.courier.consignment.created_at
                              ).toLocaleString("en-BD", {
                                timeZone: "Asia/Dhaka",
                              })}
                            </span>
                          </div>
                        )}
                      {orderObj &&
                        orderObj.courier &&
                        orderObj.courier.consignment && (
                          <div style={{ marginTop: 5 }}>
                            Consignment id:{" "}
                            <span style={{ fontWeight: "bold" }}>
                              {orderObj &&
                                orderObj.courier.consignment.consignment_id}
                            </span>
                          </div>
                        )}
                      {orderObj &&
                        orderObj.courier &&
                        orderObj.courier.consignment && (
                          <div style={{ marginTop: 5 }}>
                            Tracking Code:{" "}
                            <span style={{ fontWeight: "bold" }}>
                              {orderObj &&
                                orderObj.courier.consignment.tracking_code}
                            </span>
                          </div>
                        )}
                      <div style={{ marginTop: 5 }}>
                        Invoice:{" "}
                        <span style={{ fontWeight: "bold" }}>
                          {orderObj && orderObj.id}
                        </span>
                      </div>
                      {orderObj && (
                        <div className="wrap-info">
                          {orderObj.currentUser ? (
                            <ul>
                              <li style={{ marginTop: 5 }}>
                                Name :{" "}
                                <span style={{ fontWeight: "bold" }}>
                                  {" "}
                                  {
                                    orderObj.currentUser.address.find(
                                      (address) => address.defaultShipping
                                    ).fullName
                                  }
                                </span>
                              </li>{" "}
                              <br />
                              <li style={{ marginTop: 5 }}>
                                Mobile No :{" "}
                                <span style={{ fontWeight: "bold" }}>
                                  {" "}
                                  {
                                    orderObj.currentUser.address.find(
                                      (address) => address.defaultShipping
                                    ).mobileNo
                                  }
                                </span>
                              </li>
                              <br />
                              <li style={{ marginTop: 5 }}>
                                Address :{" "}
                                <span style={{ fontWeight: "bold" }}>
                                  {
                                    orderObj.currentUser.address.find(
                                      (address) => address.defaultShipping
                                    ).address
                                  }
                                </span>
                              </li>
                              <br />
                              <li style={{ marginTop: 5 }}>
                                District :
                                <span style={{ fontWeight: "bold" }}>
                                  {" "}
                                  {
                                    orderObj.currentUser.address.find(
                                      (address) => address.defaultShipping
                                    ).district
                                  }
                                </span>
                              </li>
                              <br />
                              <li style={{ marginTop: 5 }}>
                                Division :
                                <span style={{ fontWeight: "bold" }}>
                                  {" "}
                                  {
                                    orderObj.currentUser.address.find(
                                      (address) => address.defaultShipping
                                    ).division
                                  }
                                </span>
                              </li>
                              <br />
                              {this.state.courier == "Pathao" && (
                                <>
                                  <li style={{ marginTop: 5 }}>
                                    Parcel Weight:
                                    <span style={{ fontWeight: "bold" }}>
                                      {this.state.weight
                                        ? this.state.weight
                                        : 1}
                                      kg
                                    </span>
                                  </li>
                                  <br />
                                  <li style={{ marginTop: 5 }}>
                                    Selected City (for Pathao) :
                                    <span style={{ fontWeight: "bold" }}>
                                      {this.state.cityObject &&
                                        this.state.cityObject.city_name}
                                    </span>
                                  </li>
                                  <br />
                                  <li style={{ marginTop: 5 }}>
                                    Selected Zone (for Pathao) :
                                    <span style={{ fontWeight: "bold" }}>
                                      {" "}
                                      {this.state.zoneObject &&
                                        this.state.zoneObject.zone_name}
                                    </span>
                                  </li>
                                </>
                              )}
                            </ul>
                          ) : (
                            <ul>
                              <li style={{ marginTop: 5 }}>
                                Name :{" "}
                                <span style={{ fontWeight: "bold" }}>
                                  {" "}
                                  {
                                    orderObj.guest.address.find(
                                      (address) => address.defaultShipping
                                    ).fullName
                                  }
                                </span>
                              </li>
                              <br />
                              <li style={{ marginTop: 5 }}>
                                Mobile No :{" "}
                                <span style={{ fontWeight: "bold" }}>
                                  {" "}
                                  {
                                    orderObj.guest.address.find(
                                      (address) => address.defaultShipping
                                    ).mobileNo
                                  }
                                </span>
                              </li>
                              <br />
                              <li style={{ marginTop: 5 }}>
                                Address :{" "}
                                <span style={{ fontWeight: "bold" }}>
                                  {
                                    orderObj.guest.address.find(
                                      (address) => address.defaultShipping
                                    ).address
                                  }
                                </span>
                              </li>
                              <br />
                              <li style={{ marginTop: 5 }}>
                                District :
                                <span style={{ fontWeight: "bold" }}>
                                  {" "}
                                  {
                                    orderObj.guest.address.find(
                                      (address) => address.defaultShipping
                                    ).district
                                  }
                                </span>
                              </li>
                              <br />
                              <li style={{ marginTop: 5 }}>
                                Division :
                                <span style={{ fontWeight: "bold" }}>
                                  {" "}
                                  {
                                    orderObj.guest.address.find(
                                      (address) => address.defaultShipping
                                    ).division
                                  }
                                </span>
                              </li>{" "}
                              <br />
                              {this.state.courier == "Pathao" && (
                                <>
                                  {!orderObj.courier && (
                                    <li style={{ marginTop: 5 }}>
                                      Parcel Weight:
                                      <span style={{ fontWeight: "bold" }}>
                                        {this.state.weight && this.state.weight}
                                        kg
                                      </span>
                                    </li>
                                  )}

                                  {!orderObj.courier && (
                                    <>
                                      {" "}
                                      <br />
                                      <li style={{ marginTop: 5 }}>
                                        Selected City (for Pathao) :
                                        <span style={{ fontWeight: "bold" }}>
                                          {this.state.cityObject &&
                                            this.state.cityObject.city_name}
                                        </span>
                                      </li>
                                    </>
                                  )}

                                  {!orderObj.courier && (
                                    <>
                                      <br />
                                      <li style={{ marginTop: 5 }}>
                                        Selected Zone (for Pathao) :
                                        <span style={{ fontWeight: "bold" }}>
                                          {" "}
                                          {this.state.zoneObject &&
                                            this.state.zoneObject.zone_name}
                                        </span>
                                      </li>
                                    </>
                                  )}
                                </>
                              )}
                            </ul>
                          )}
                        </div>
                      )}
                      <div style={{ marginTop: 5 }}>
                        COD Amount:{" "}
                        <span style={{ fontWeight: "bold" }}>
                          {amountPayable - totalPaid}
                          Tk
                        </span>
                      </div>
                      <div style={{ marginTop: 5 }}>
                        Note: <br />
                        <span
                          style={{
                            fontSize: 12,
                            marginTop: 2,
                            fontWeight: "bold",
                          }}
                        >
                          {!orderObj.courier
                            ? this.state.note
                            : orderObj.courier.note}
                        </span>
                      </div>
                    </div>
                  </div>
                  {orderObj &&
                    orderObj.courier &&
                    orderObj.courier.consignment && (
                      <div style={{ marginLeft: 12 }}>
                        <div style={{ fontWeight: "bold" }}>
                          Tracking Details
                        </div>
                        <div style={{ marginTop: 5 }}>
                          Delivery Status:{" "}
                          <span
                            style={{
                              fontWeight: "bold",
                              color: "white",
                              background: "#00B795",
                              borderRadius: 5,
                              padding: "0px 10px",
                            }}
                          >
                            {orderObj.deliveryStatus}
                          </span>
                        </div>
                        <div style={{ marginTop: 5 }}>
                          Status Details:{" "}
                          <span style={{ fontWeight: "bold" }}>
                            {orderObj.deliveryStatusDescription}
                          </span>
                        </div>
                      </div>
                    )}
                  {orderObj && orderObj.courier && orderObj.courier.pathao && (
                    <div style={{ marginLeft: 12 }}>
                      <div style={{ fontWeight: "bold" }}>Tracking Details</div>
                      <div style={{ marginTop: 5 }}>
                        Delivery Status:{" "}
                        <span
                          style={{
                            fontWeight: "bold",
                            color: "white",
                            background: "#00B795",
                            borderRadius: 5,
                            padding: "0px 10px",
                          }}
                        >
                          {orderObj.deliveryStatus}
                        </span>
                      </div>
                      <div style={{ marginTop: 5 }}>
                        Status Details:{" "}
                        <span style={{ fontWeight: "bold" }}>
                          {orderObj.deliveryStatusDescription}
                        </span>
                      </div>
                    </div>
                  )}
                </div>
              )}

              {orderObj && !orderObj.courier && (
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn "
                    data-dismiss="modal"
                    style={{
                      backgroundColor: "red",
                      color: "white",
                      padding: 8,
                      borderRadius: 5,
                      fontWeight: "lighter",
                    }}
                  >
                    No
                  </button>
                  <button
                    type="button"
                    className="btn"
                    style={{
                      backgroundColor: "darkgreen",
                      color: "white",
                      padding: 8,
                      borderRadius: 5,
                      fontWeight: "lighter",
                    }}
                    onClick={() => {
                      this.handleCourier(amountPayable - totalPaid);
                    }}
                  >
                    Yes
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
        <div
          className="modal fade"
          id="paymentModal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div
            className="modal-dialog"
            role="document"
            style={{ margin: "auto" }}
          >
            <div
              className="modal-content"
              style={{ top: 10, width: "100%", margin: "auto" }}
            >
              <div
                className="modal-header"
                style={{
                  backgroundColor: "rgb(251, 148, 4)",
                  paddingTop: 20,
                  paddingBottom: 20,
                }}
              >
                <div
                  className="modal-title"
                  style={{
                    fontWeight: "bold",
                    fontSize: 17,
                    color: "white",
                  }}
                  id="exampleModalLabel"
                >
                  Receive Payment
                </div>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  id="personal-info-close"
                >
                  <span aria-hidden="true" style={{ color: "white" }}>
                    &times;
                  </span>
                </button>
              </div>
              {orderObj && (
                <div className="modal-body">
                  <div
                    className="row"
                    style={{
                      marginBottom: 10,
                      borderBottom: "1px solid gainsboro",
                    }}
                  >
                    <div className="col">
                      <div
                        style={{
                          padding: 10,
                          fontWeight: "bold",
                          paddingTop: 0,
                          color: "black",
                        }}
                      >
                        Order Information
                      </div>
                      <div
                        style={{
                          padding: 10,
                          fontWeight: "bold",
                          paddingTop: 0,
                        }}
                      >
                        Order Id:{" "}
                        <span style={{ fontWeight: "lighter" }}>
                          {" "}
                          #{orderObj && orderObj.id}
                        </span>
                      </div>
                      <div
                        style={{
                          padding: 10,
                          fontWeight: "bold",
                          paddingTop: 0,
                        }}
                      >
                        Ordered at:{" "}
                        <span style={{ fontWeight: "lighter" }}>
                          {" "}
                          {orderObj &&
                            new Date(
                              Number(orderObj.date)
                            ).toLocaleDateString()}
                          {"  "}
                          {orderObj &&
                            new Date(
                              Number(orderObj.date)
                            ).toLocaleTimeString()}
                        </span>
                      </div>
                      <div
                        style={{
                          padding: 10,
                          fontWeight: "bold",
                          paddingTop: 0,
                        }}
                      >
                        Order Status:{" "}
                        <span
                          style={{
                            padding: 10,
                            fontWeight: "bold",
                            paddingTop: 0,
                            color: "white",
                            padding: "3px 7px",
                            borderRadius: 5,
                            backgroundColor: orderObj
                              ? orderObj.orderStatus == "Processing"
                                ? "#0f0fd9"
                                : orderObj.orderStatus == "Confirmed"
                                ? "orange"
                                : orderObj.orderStatus == "Packing"
                                ? "darkorange"
                                : orderObj.orderStatus == "On the way"
                                ? "green"
                                : orderObj.orderStatus == "Delivered"
                                ? "green"
                                : orderObj.orderStatus == "Cancelled"
                                ? "red"
                                : "white"
                              : "white",
                            textAlign: "center",
                            fontSize: 12,
                          }}
                        >
                          {orderObj && orderObj.orderStatus}
                        </span>
                      </div>
                      <div
                        style={{
                          padding: 10,
                          fontWeight: "bold",
                          paddingTop: 0,
                        }}
                      >
                        Subtotal:{" "}
                        <span style={{ fontWeight: "lighter" }}>
                          {" "}
                          ৳{orderObj && orderObj.subTotal}
                        </span>
                      </div>
                      <div
                        style={{
                          padding: 10,
                          fontWeight: "bold",
                          paddingTop: 0,
                        }}
                      >
                        Delivery Charge:{" "}
                        <span style={{ fontWeight: "lighter" }}>
                          {" "}
                          ৳ {(orderObj && orderObj.deliveryCharge) || "0"}
                        </span>
                      </div>
                      <div
                        style={{
                          padding: 10,
                          fontWeight: "bold",
                          paddingTop: 0,
                        }}
                      >
                        Discount Applied:{" "}
                        <span style={{ fontWeight: "lighter" }}>
                          {" "}
                          ৳ {(orderObj && orderObj.discountApplied) || "0"}
                        </span>
                      </div>
                      {orderObj && orderObj.couponApplied && (
                        <div
                          style={{
                            padding: 10,
                            fontWeight: "bold",
                            paddingTop: 0,
                          }}
                        >
                          Coupon Applied{" "}
                          <span
                            style={{
                              color: "rgb(251, 148, 4)",
                              fontWeight: "bold",
                              fontSize: 12,
                            }}
                          >
                            {" "}
                            ({orderObj.couponApplied.name})
                          </span>
                          :{" "}
                          <span style={{ fontWeight: "lighter" }}>
                            {" "}
                            ৳{" "}
                            {(orderObj && orderObj.couponApplied.discount) || 0}
                          </span>
                        </div>
                      )}
                      <div
                        style={{
                          padding: 10,
                          fontWeight: "bold",
                          paddingTop: 0,
                        }}
                      >
                        Amount Payable:{" "}
                        <span style={{ fontWeight: "bold" }}>
                          ৳{" "}
                          {orderObj &&
                            orderObj.subTotal +
                              orderObj.deliveryCharge -
                              orderObj.discountApplied -
                              (orderObj.couponApplied
                                ? orderObj.couponApplied.discount
                                : 0)}
                        </span>
                      </div>
                      <div
                        style={{
                          padding: 10,
                          fontWeight: "bold",
                          paddingTop: 0,
                        }}
                      >
                        Final Discount:{" "}
                        <span style={{ fontWeight: "bold" }}>
                          -৳{" "}
                          {orderObj && orderObj.finalDiscount
                            ? orderObj.finalDiscount
                            : 0}
                        </span>
                      </div>
                      <div
                        style={{
                          padding: 10,
                          fontWeight: "bold",
                          paddingTop: 0,
                        }}
                      >
                        Amount Payable{" "}
                        <span style={{ fontSize: 11 }}>(after discount)</span>:{" "}
                        <span style={{ fontWeight: "bold" }}>
                          ৳{" "}
                          {orderObj &&
                            orderObj.subTotal +
                              orderObj.deliveryCharge -
                              orderObj.discountApplied -
                              (orderObj.couponApplied
                                ? orderObj.couponApplied.discount
                                : 0) -
                              (orderObj.finalDiscount
                                ? orderObj.finalDiscount
                                : 0)}
                        </span>
                      </div>
                      <div
                        style={{
                          padding: 10,
                          fontWeight: "bold",
                          paddingTop: 0,
                        }}
                      >
                        Total Paid:{" "}
                        <span style={{ fontWeight: "bold" }}>
                          ৳ {totalPaid}
                        </span>
                      </div>
                      <div
                        style={{
                          padding: 10,
                          fontWeight: "bold",
                          paddingTop: 0,
                          color: "red",
                        }}
                      >
                        Total Due:{" "}
                        <span style={{ fontWeight: "bold" }}>
                          ৳ {amountPayable - totalPaid}
                        </span>
                      </div>
                      <div
                        style={{
                          padding: 10,
                          fontWeight: "bold",
                          paddingTop: 0,
                          marginTop: 5,
                        }}
                      >
                        Courier Charge:{" "}
                        <span style={{ fontWeight: "bold" }}>
                          ৳{" "}
                          {orderObj && orderObj.courierCharge
                            ? orderObj.courierCharge
                            : 0}
                        </span>
                      </div>
                    </div>
                  </div>

                  {this.props.currentAdmin &&
                  (this.props.currentAdmin.status == "Admin" ||
                    this.props.currentAdmin.status == "Accounts") ? (
                    <>
                      <div className="row">
                        <div className="col">
                          <form
                            onSubmit={(e) => {
                              this.handleSubmit2(
                                e,
                                parseInt(amountPayable) - parseInt(totalPaid)
                              );
                            }}
                            className="rounded-field mt-2"
                          >
                            <div className="form-row mb-2">
                              <div className="col">
                                <label
                                  style={{
                                    marginBottom: 0,
                                    fontSize: 13,
                                    fontWeight: "bold",
                                  }}
                                >
                                  Payment Method
                                </label>

                                <select
                                  title=""
                                  name="method"
                                  className="custom-select"
                                  aria-required="true"
                                  aria-invalid="false"
                                  onChange={this.handleChange}
                                  style={{ fontSize: ".8rem" }}
                                  value={this.state.method}
                                  required
                                >
                                  <option value="">Select Method</option>
                                  <option value="Cash">Cash</option>
                                  <option value="Bkash">Bkash</option>
                                  <option value="Nagad">Nagad</option>
                                  <option value="Rocket">Rocket</option>
                                  <option value="Eastern Bank">
                                    Easter Bank
                                  </option>
                                  <option value="Courier (COD)">
                                    Courier (COD)
                                  </option>
                                </select>
                              </div>
                              <div className="col">
                                <label
                                  style={{
                                    marginBottom: 0,
                                    fontSize: 13,
                                    fontWeight: "bold",
                                  }}
                                >
                                  Paid amount
                                </label>

                                <input
                                  type="number"
                                  name="amount"
                                  className="form-control"
                                  placeholder="Enter amount"
                                  style={{ fontSize: "1rem" }}
                                  onChange={this.handleChange}
                                  value={this.state.amount}
                                  required
                                />
                              </div>
                              <div className="col">
                                <label
                                  style={{
                                    marginBottom: 0,
                                    fontSize: 13,
                                    fontWeight: "bold",
                                  }}
                                >
                                  Payment Status
                                </label>

                                <select
                                  title=""
                                  name="paymentStatus"
                                  className="custom-select"
                                  aria-required="true"
                                  aria-invalid="false"
                                  onChange={this.handleChange}
                                  style={{ fontSize: ".8rem" }}
                                  value={this.state.paymentStatus}
                                  required
                                >
                                  <option value="">
                                    Select Payment Status
                                  </option>
                                  <option value="Partially Paid">
                                    Partially Paid
                                  </option>
                                  <option value="Paid">Full Paid</option>
                                </select>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col">
                                <label
                                  style={{
                                    marginBottom: 0,
                                    fontSize: 13,
                                    fontWeight: "bold",
                                  }}
                                >
                                  Transaction Id
                                </label>

                                <input
                                  type="text"
                                  name="transactionId"
                                  className="form-control"
                                  placeholder="Enter transaction Id"
                                  style={{ fontSize: "1rem" }}
                                  onChange={this.handleChange}
                                  value={this.state.transactionId}
                                  required
                                />
                              </div>
                            </div>

                            <div className="form-row">
                              <div
                                className="col pt-3"
                                style={{
                                  display: "flex",
                                  justifyContent: "flex-end",
                                }}
                              >
                                {this.state.loader ? (
                                  <div
                                    style={{
                                      background: "rgb(251, 148, 4)",
                                      color: "white",
                                      minWidth: 150,
                                      padding: 10,
                                      borderRadius: 10,
                                    }}
                                  >
                                    <ClipLoader
                                      size={18}
                                      color={"white"}
                                      loading={this.state.loader}
                                    />
                                  </div>
                                ) : (
                                  <button
                                    type="submit"
                                    className="btn"
                                    style={{
                                      background: "rgb(251, 148, 4)",
                                      color: "white",
                                    }}
                                  >
                                    Update
                                    <i className="icofont-rounded-right"></i>
                                  </button>
                                )}
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                      <div
                        className="row"
                        style={{
                          borderTop: "1px solid gainsboro",
                          marginTop: 20,
                        }}
                      >
                        <div className="col">
                          <form
                            onSubmit={(e) => {
                              this.handleSubmit3(e);
                            }}
                            className="rounded-field mt-2"
                          >
                            <div className="form-row mb-2">
                              <div className="col">
                                <label
                                  style={{
                                    marginBottom: 0,
                                    fontSize: 13,
                                    fontWeight: "bold",
                                  }}
                                >
                                  Courier charge
                                </label>

                                <input
                                  type="number"
                                  name="courierCharge"
                                  className="form-control"
                                  placeholder="Enter amount"
                                  style={{ fontSize: "1rem" }}
                                  onChange={this.handleChange}
                                  value={this.state.courierCharge}
                                  required
                                />
                              </div>
                            </div>

                            <div className="form-row">
                              <div
                                className="col pt-3"
                                style={{
                                  display: "flex",
                                  justifyContent: "flex-end",
                                }}
                              >
                                {this.state.loader3 ? (
                                  <div
                                    style={{
                                      background: "rgb(251, 148, 4)",
                                      color: "white",
                                      minWidth: 150,
                                      padding: 10,
                                      borderRadius: 10,
                                    }}
                                  >
                                    <ClipLoader
                                      size={18}
                                      color={"white"}
                                      loading={this.state.loader3}
                                    />
                                  </div>
                                ) : (
                                  <button
                                    type="submit"
                                    className="btn"
                                    style={{
                                      background: "rgb(251, 148, 4)",
                                      color: "white",
                                    }}
                                  >
                                    Update
                                    <i className="icofont-rounded-right"></i>
                                  </button>
                                )}
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </>
                  ) : null}
                  <div className="row">
                    {orderObj &&
                      orderObj.payments &&
                      orderObj.payments.length > 0 && (
                        <div className="col">
                          <div
                            className="row"
                            style={{
                              height: 1,
                              width: "100%",
                              background: "gainsboro",
                              marginTop: 20,
                              marginBottom: 20,
                              marginRight: 0,
                              marginLeft: 0,
                            }}
                          ></div>
                          <div
                            style={{
                              paddingLeft: 0,
                              color: "#18768f",
                              fontWeight: "bold",
                            }}
                          >
                            Previous Payments
                          </div>
                          <table className="table table-bordered table-striped table-hover">
                            <thead
                              style={{ background: "#18768f", color: "white" }}
                            >
                              <tr>
                                <td style={{ fontWeight: "bold" }}>Date</td>
                                <td style={{ fontWeight: "bold" }}>Method</td>
                                <td style={{ fontWeight: "bold" }}>
                                  Transaction Id
                                </td>
                                <td style={{ fontWeight: "bold" }}>Amount</td>

                                <td style={{ fontWeight: "bold" }}>
                                  Approved by
                                </td>
                              </tr>
                            </thead>
                            <tbody>
                              {orderObj.payments.map((payment) => (
                                <tr>
                                  <td>{payment.date}</td>
                                  <td>{payment.method}</td>
                                  <td>{payment.transactionId}</td>
                                  <td>{payment.amount}Tk</td>
                                  <td>{payment.receivedBy}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      )}
                  </div>
                </div>
              )}

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn "
                  data-dismiss="modal"
                  id="close-button-for-payment-modal"
                  style={{
                    backgroundColor: "darkgreen",
                    color: "white",
                    padding: 8,
                    borderRadius: 5,
                    fontWeight: "lighter",
                  }}
                  onClick={() => {
                    this.setState({
                      orderObj: null,
                    });
                  }}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal fade"
          id="detailInfoModal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div
            className="modal-dialog"
            role="document"
            style={{
              margin: "auto",
              minWidth: "60%",
              maxHeight: "80%",
              overflowY: "scroll",
            }}
          >
            <div className="modal-content" style={{ top: 10, margin: "auto" }}>
              <div
                className="modal-header"
                style={{
                  backgroundColor: "rgb(251, 148, 4)",
                  paddingTop: 20,
                  paddingBottom: 20,
                }}
              >
                <div
                  className="modal-title"
                  style={{
                    fontWeight: "bold",
                    fontSize: 17,
                    color: "white",
                  }}
                  id="exampleModalLabel"
                >
                  Order Id: {orderObj && orderObj.id}
                </div>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  id="personal-info-close"
                >
                  <span aria-hidden="true" style={{ color: "white" }}>
                    &times;
                  </span>
                </button>
              </div>
              <div className="modal-body">
                <div style={{ padding: "10px 15px" }}></div>
                <div
                  className="row"
                  style={{
                    marginBottom: 10,
                    borderBottom: "1px solid gainsboro",
                  }}
                >
                  <div className="col">
                    <div
                      style={{
                        padding: 10,
                        fontWeight: "bold",
                        paddingTop: 0,
                        color: "gray",
                      }}
                    >
                      Order Information
                    </div>
                    <div
                      style={{
                        padding: 10,
                        fontWeight: "bold",
                        paddingTop: 0,
                      }}
                    >
                      Order Id:{" "}
                      <span style={{ fontWeight: "lighter" }}>
                        {" "}
                        #{orderObj && orderObj.id}
                      </span>
                    </div>
                    <div
                      style={{
                        padding: 10,
                        fontWeight: "bold",
                        paddingTop: 0,
                      }}
                    >
                      Ordered at:{" "}
                      <span style={{ fontWeight: "lighter" }}>
                        {" "}
                        {orderObj &&
                          new Date(Number(orderObj.date)).toLocaleDateString()}
                        {"  "}
                        {orderObj &&
                          new Date(Number(orderObj.date)).toLocaleTimeString()}
                      </span>
                    </div>
                    <div
                      style={{
                        padding: 10,
                        fontWeight: "bold",
                        paddingTop: 0,
                      }}
                    >
                      Order Status:{" "}
                      <span
                        style={{
                          padding: 10,
                          fontWeight: "bold",
                          paddingTop: 0,
                          color: "white",
                          padding: "3px 7px",
                          borderRadius: 5,
                          backgroundColor: orderObj
                            ? orderObj.orderStatus == "Processing"
                              ? "#0f0fd9"
                              : orderObj.orderStatus == "Confirmed"
                              ? "orange"
                              : orderObj.orderStatus == "Packing"
                              ? "darkorange"
                              : orderObj.orderStatus == "On the way"
                              ? "green"
                              : orderObj.orderStatus == "Delivered"
                              ? "green"
                              : orderObj.orderStatus == "Cancelled"
                              ? "red"
                              : "white"
                            : "white",
                          textAlign: "center",
                          fontSize: 12,
                        }}
                      >
                        {orderObj && orderObj.orderStatus}
                      </span>
                    </div>
                    <div
                      style={{
                        padding: 10,
                        fontWeight: "bold",
                        paddingTop: 0,
                      }}
                    >
                      Subtotal:{" "}
                      <span style={{ fontWeight: "lighter" }}>
                        {" "}
                        ৳{orderObj && orderObj.subTotal}
                      </span>
                    </div>
                    <div
                      style={{
                        padding: 10,
                        fontWeight: "bold",
                        paddingTop: 0,
                      }}
                    >
                      Delivery Charge:{" "}
                      <span style={{ fontWeight: "lighter" }}>
                        {" "}
                        ৳ {(orderObj && orderObj.deliveryCharge) || "0"}
                      </span>
                    </div>
                    <div
                      style={{
                        padding: 10,
                        fontWeight: "bold",
                        paddingTop: 0,
                      }}
                    >
                      Discount Applied:{" "}
                      <span style={{ fontWeight: "lighter" }}>
                        {" "}
                        ৳ {(orderObj && orderObj.discountApplied) || "0"}
                      </span>
                    </div>
                    {orderObj && orderObj.couponApplied && (
                      <div
                        style={{
                          padding: 10,
                          fontWeight: "bold",
                          paddingTop: 0,
                        }}
                      >
                        Coupon Applied{" "}
                        <span
                          style={{
                            color: "rgb(251, 148, 4)",
                            fontWeight: "bold",
                            fontSize: 12,
                          }}
                        >
                          {" "}
                          ({orderObj.couponApplied.name})
                        </span>
                        :{" "}
                        <span style={{ fontWeight: "lighter" }}>
                          {" "}
                          ৳ {(orderObj && orderObj.couponApplied.discount) || 0}
                        </span>
                      </div>
                    )}
                    <div
                      style={{
                        padding: 10,
                        fontWeight: "bold",
                        paddingTop: 0,
                      }}
                    >
                      Amount Payable:{" "}
                      <span style={{ fontWeight: "bold" }}>
                        ৳{" "}
                        {orderObj &&
                          orderObj.subTotal +
                            orderObj.deliveryCharge -
                            orderObj.discountApplied -
                            (orderObj.couponApplied
                              ? orderObj.couponApplied.discount
                              : 0)}
                      </span>
                    </div>
                    <div
                      style={{
                        padding: 10,
                        fontWeight: "bold",
                        paddingTop: 0,
                      }}
                    >
                      Final Discount:{" "}
                      <span style={{ fontWeight: "bold" }}>
                        ৳{" "}
                        {orderObj && orderObj.finalDiscount
                          ? orderObj.finalDiscount
                          : 0}
                      </span>
                    </div>
                    <div
                      style={{
                        padding: 10,
                        fontWeight: "bold",
                        paddingTop: 0,
                      }}
                    >
                      Amount Payable{" "}
                      <span style={{ fontSize: 11 }}>(after discount)</span>
                      <span style={{ fontWeight: "bold" }}>
                        ৳{" "}
                        {orderObj &&
                          orderObj.subTotal +
                            orderObj.deliveryCharge -
                            orderObj.discountApplied -
                            (orderObj.couponApplied
                              ? orderObj.couponApplied.discount
                              : 0) -
                            (orderObj.finalDiscount
                              ? orderObj.finalDiscount
                              : 0)}
                      </span>
                    </div>
                    {orderObj && orderObj.cancelNote && (
                      <div
                        style={{
                          padding: 10,
                          fontWeight: "bold",
                          paddingTop: 0,
                        }}
                      >
                        Cancellation Note:{" "}
                        <span
                          style={{
                            fontWeight: "bold",
                            fontSize: 13,
                            color: "gray",
                          }}
                        >
                          {orderObj.cancelNote}
                        </span>
                      </div>
                    )}
                  </div>
                  <div className="col">
                    <div
                      style={{
                        padding: 10,
                        fontWeight: "bold",
                        paddingTop: 0,
                        color: "gray",
                      }}
                    >
                      Schedule Information
                    </div>
                    <div
                      style={{
                        padding: 10,
                        fontWeight: "bold",
                        paddingTop: 0,
                      }}
                    >
                      Order Date:{" "}
                      <span style={{ fontWeight: "lighter" }}>
                        {orderObj &&
                          new Date(Number(orderObj.date)).toLocaleDateString()}
                      </span>
                    </div>
                    <div
                      style={{
                        padding: 10,
                        fontWeight: "bold",
                        paddingTop: 0,
                      }}
                    >
                      Confirmed Date:{" "}
                      <span style={{ fontWeight: "lighter" }}>
                        {orderObj &&
                          orderObj.confirmedDate &&
                          new Date(
                            Number(orderObj.confirmedDate)
                          ).toLocaleDateString()}
                      </span>
                    </div>
                    <div
                      style={{
                        padding: 10,
                        fontWeight: "bold",
                        paddingTop: 0,
                      }}
                    >
                      Packing Date:{" "}
                      <span style={{ fontWeight: "lighter" }}>
                        {orderObj &&
                          orderObj.packingDate &&
                          new Date(
                            Number(orderObj.packingDate)
                          ).toLocaleDateString()}
                      </span>
                    </div>
                    <div
                      style={{
                        padding: 10,
                        fontWeight: "bold",
                        paddingTop: 0,
                      }}
                    >
                      Delivered Date:{" "}
                      <span style={{ fontWeight: "lighter" }}>
                        {orderObj &&
                          orderObj.deliveredDate &&
                          new Date(
                            Number(orderObj.deliveredDate)
                          ).toLocaleDateString()}
                      </span>
                    </div>
                    {orderObj && orderObj.cancelledDate && (
                      <div
                        style={{
                          padding: 10,
                          fontWeight: "bold",
                          paddingTop: 0,
                        }}
                      >
                        Cancelled Date:{" "}
                        <span style={{ fontWeight: "lighter" }}>
                          {orderObj &&
                            orderObj.cancelledDate &&
                            new Date(
                              Number(orderObj.cancelledDate)
                            ).toLocaleDateString()}
                        </span>
                      </div>
                    )}
                    {orderObj && orderObj.orderNote && (
                      <div
                        style={{
                          padding: 10,
                          fontWeight: "bold",
                          paddingTop: 0,
                          marginTop: 30,
                        }}
                      >
                        Order note:{" "}
                        <span style={{ fontWeight: "lighter" }}>
                          {orderObj && orderObj.orderNote}
                        </span>
                      </div>
                    )}
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    <div
                      style={{
                        padding: 10,
                        fontWeight: "bold",
                        paddingTop: 0,
                        color: "gray",
                      }}
                    >
                      Customer Information
                    </div>
                    <div
                      style={{
                        padding: 10,
                        fontWeight: "bold",
                        paddingTop: 0,
                      }}
                    >
                      Customer Id:{" "}
                      <span style={{ fontWeight: "lighter" }}>
                        {orderObj && orderObj.currentUser.uid}
                      </span>
                    </div>
                    <div
                      style={{
                        padding: 10,
                        fontWeight: "bold",
                        paddingTop: 0,
                      }}
                    >
                      Customer Name:{" "}
                      <span style={{ fontWeight: "lighter" }}>
                        {orderObj && orderObj.currentUser.displayName}
                      </span>
                    </div>
                    <div
                      style={{
                        padding: 10,
                        fontWeight: "bold",
                        paddingTop: 0,
                      }}
                    >
                      Customer Email:{" "}
                      <span style={{ fontWeight: "lighter" }}>
                        {orderObj && orderObj.currentUser.email}
                      </span>
                    </div>
                    <div
                      style={{
                        padding: 10,
                        fontWeight: "bold",
                        paddingTop: 0,
                      }}
                    >
                      Customer Mobile No:{" "}
                      <span style={{ fontWeight: "lighter" }}>
                        {orderObj && orderObj.currentUser.mobielNumber}
                      </span>
                    </div>
                  </div>
                  <div className="col">
                    <div
                      style={{
                        padding: 10,
                        fontWeight: "bold",
                        paddingTop: 0,
                        color: "gray",
                      }}
                    >
                      Delivery Information
                    </div>
                    <div
                      style={{
                        padding: 10,
                        fontWeight: "bold",
                        paddingTop: 0,
                      }}
                    >
                      Name :{" "}
                      <span style={{ fontWeight: "lighter" }}>
                        {deliveryAddress && deliveryAddress.fullName}
                      </span>
                    </div>
                    <div
                      style={{
                        padding: 10,
                        fontWeight: "bold",
                        paddingTop: 0,
                      }}
                    >
                      Mobile :{" "}
                      <span style={{ fontWeight: "lighter" }}>
                        {deliveryAddress && deliveryAddress.mobileNo}
                      </span>
                    </div>
                    <div
                      style={{
                        padding: 10,
                        fontWeight: "bold",
                        paddingTop: 0,
                      }}
                    >
                      Address :{" "}
                      <span style={{ fontWeight: "lighter" }}>
                        {deliveryAddress && deliveryAddress.address}
                      </span>
                    </div>
                    <div
                      style={{
                        padding: 10,
                        fontWeight: "bold",
                        paddingTop: 0,
                      }}
                    >
                      District :{" "}
                      <span style={{ fontWeight: "lighter" }}>
                        {deliveryAddress && deliveryAddress.district}
                      </span>
                    </div>
                    <div
                      style={{
                        padding: 10,
                        fontWeight: "bold",
                        paddingTop: 0,
                      }}
                    >
                      Division :{" "}
                      <span style={{ fontWeight: "lighter" }}>
                        {deliveryAddress && deliveryAddress.division}
                      </span>
                    </div>
                  </div>
                </div>
                <div style={{ marginTop: 30 }}></div>
                <table className="table table-bordered table-striped table-hover">
                  <thead>
                    <tr>
                      <td style={{ fontWeight: "bold" }}>Product Image</td>
                      <td style={{ fontWeight: "bold" }}>Product Name</td>
                      <td style={{ fontWeight: "bold" }}>Product Price</td>
                      <td style={{ fontWeight: "bold" }}>Total Quantity</td>
                      <td style={{ fontWeight: "bold" }}>
                        Available Stock <br />{" "}
                        <span style={{ fontSize: 12, color: "gray" }}>
                          at the time of order
                        </span>
                      </td>
                      <td style={{ fontWeight: "bold" }}>Total Price</td>
                    </tr>
                  </thead>
                  <tbody>
                    {orderObj &&
                      orderObj.orders.map((order) => (
                        <tr key={order.id}>
                          <td>
                            <img
                              style={{ height: 70, width: 70 }}
                              src={
                                order.selectedVariation &&
                                order.selectedVariation.id &&
                                order.selectedVariation.pictures &&
                                order.selectedVariation.pictures.length > 0
                                  ? order.selectedVariation.pictures[0]
                                  : order.product.pictures[0]
                              }
                            />
                          </td>
                          <td>
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <div style={{ fontWeight: "bold" }}>
                                {order.product.name.slice(0, 50)}...
                              </div>
                              {order.product.selectedCategories &&
                                order.product.selectedCategories.length > 0 &&
                                order.product.selectedCategories
                                  .slice(0, 2)
                                  .map((cat, index) => (
                                    <div
                                      key={index}
                                      style={{
                                        fontSize: 14,
                                        color: "#444",
                                      }}
                                    >
                                      {cat.name}
                                    </div>
                                  ))}

                              <div style={{ marginTop: 6 }}>
                                {order.selectedVariation &&
                                  order.selectedVariation.id &&
                                  order.selectedVariation.combination.map(
                                    (comb, index) => (
                                      <div key={index}>
                                        {order.product.savedAttributes.find(
                                          (attr) => attr.id == comb.parentId
                                        )
                                          ? order.product.savedAttributes.find(
                                              (attr) => attr.id == comb.parentId
                                            ).name
                                          : ""}
                                        : {comb.name}
                                      </div>
                                    )
                                  )}
                              </div>
                              <div>
                                Total:৳ {this.singleProductTotal(order)} (
                                {order.quantity}pc)
                              </div>
                            </div>
                          </td>
                          <td>
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "space-around",
                              }}
                            >
                              {" "}
                              <div
                                style={{
                                  fontSize: 13,
                                  textDecorationLine: "line-through",
                                  color: "gray",
                                }}
                              >
                                {this.getPrice3(order)}{" "}
                              </div>
                              <div
                                style={{
                                  color: "black",
                                  fontSize: 13,
                                  fontWeight: "bold",
                                }}
                              >
                                ৳ {this.getPrice2(order)}
                              </div>
                            </div>
                          </td>
                          <td>{order.quantity}Pc</td>
                          <td>
                            {order.selectedVariation &&
                            order.selectedVariation.inventory
                              ? order.selectedVariation.inventory
                              : order.product.inventory}
                            Pc
                          </td>

                          <td style={{ fontWeight: "bold" }}>
                            ৳ {this.singleProductTotal(order)}
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-dismiss="modal"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
        {hasMore && this.state.loading5 && (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              marginTop: 30,
            }}
          >
            {" "}
            <ClipLoader color="#ff8084" size={60} />
          </div>
        )}

        <ReactToPrint
          ref={(el) => (this.reactToPrintTrigger = el)} // <-- ref
          content={() => this.componentRef}
        />

        <div style={{ display: "none" }}>
          <div
            ref={(el) => (this.componentRef = el)}
            className="print-area-2"
            style={{ background: "white" }}
          >
            <div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                }}
              >
                <img
                  className="blur-up lazyloaded"
                  src={logo}
                  alt=""
                  style={{ maxWidth: "40%" }}
                />
              </div>
              <div style={{ textAlign: "center", fontSize: 13 }}>
                44/45, 5th floor,Bikrampur Housing, New
                Alibohar,Postogola,Dhaka-1204
              </div>
              <div
                style={{
                  border: "1px solid black",
                  borderLeft: "none",
                  borderRight: "none",
                  padding: 7,
                  fontWeight: "bold",
                  fontSize: 17,
                  textAlign: "center",
                  marginTop: 6,
                }}
              >
                CN#
                {orderObj &&
                  orderObj.courier &&
                  orderObj.courier.consignment &&
                  orderObj.courier.consignment.consignment_id}
              </div>
              <div style={{ padding: 10 }}>
                <div style={{ fontWeight: "bold", fontSize: 14 }}>SHIP TO,</div>
                <div style={{ fontSize: 14 }}>
                  Customer: {this.getDeliveryAddress(orderObj)?.fullName}
                </div>
                <div style={{ fontSize: 14 }}>
                  Mobile: {this.getDeliveryAddress(orderObj)?.mobileNo}
                </div>
                <div
                  style={{
                    fontSize: 14,

                    lineHeight: "16px",
                    display: "-webkit-box",
                    WebkitLineClamp: 4, // LIMIT TO 4 LINES
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden",
                  }}
                >
                  Address: {this.getDeliveryAddress(orderObj)?.address}
                </div>
                <div style={{ fontSize: 14 }}>
                  {this.getDeliveryAddress(orderObj)?.district},
                  {this.getDeliveryAddress(orderObj)?.division}
                </div>
              </div>
              <div style={{ padding: 10 }}>
                <div style={{ fontWeight: "bold", fontSize: 18 }}>
                  COD: ৳ {this.getTotalDue(orderObj)}
                </div>
              </div>
              <div
                style={{
                  position: "absolute",
                  bottom: 5,
                  left: 0,
                  padding: 10,
                  width: "100%",
                  background: "white",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <div style={{ fontWeight: "bold", fontSize: 10 }}>
                    Thank you for staying with us
                  </div>
                  <div style={{ fontWeight: "bold", fontSize: 10 }}>
                    zapai.com.bd
                  </div>
                </div>
                <div
                  style={{
                    width: "100%",
                    height: 40,
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    marginTop: 5,
                    fontSize: 16,
                    background: "white",
                  }}
                >
                  <div>
                    <Barcode
                      value={orderObj?.id || "DEFAULTID"}
                      width={1.5} // width of each bar
                      height={30} // barcode height
                      displayValue={true} // show the text under the barcode
                      margin={0}
                      format="CODE128" // standard format
                      fontSize={15}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    currentAdmin: state.admins.currentAdmin,
    orders: state.orders.orders,
    hasMore: state.orders.hasMore,
    lastVisible: state.orders.lastVisible,
  };
};

export default connect(mapStateToProps, {
  getAllOrdersRedux,
  updateOrderRedux,
  uploadCashInRedux,
  uploadTransactionRedux,
  updateSingleProductRedux,
  uploadExpenseRedux,
})(Orders);
